import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  EmailAddress: { input: any; output: any; }
};

export type AccountStatuses = {
  __typename?: 'AccountStatuses';
  /** active returns the number of active accounts in Klarity Core */
  active: Scalars['String']['output'];
  /** discovered returns the number of discovered accounts in Klarity Core */
  discovered: Scalars['String']['output'];
  /** inactive active returns the number of inactive accounts in Klarity Core */
  inactive: Scalars['String']['output'];
  /** provider indicates the provider for which active/inactive/discovered are provided */
  provider: Provider;
};

export type AddAdmin = {
  email: Scalars['EmailAddress']['input'];
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type AddApiKey = {
  /** Information regarding the expected usage of the key */
  description: Scalars['String']['input'];
};

export type AddFleetControlTenant = {
  /** @deprecated All organization admins used by default */
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  location: FleetControlTenantLocation;
  name: Scalars['String']['input'];
  regions: Array<Scalars['String']['input']>;
};

export type AddImageFactoryTenant = {
  name: Scalars['String']['input'];
  operatingSystems: Array<ImageFactoryOperatingSystem>;
  providers: Array<ImageFactoryProvider>;
};

export type AddKlarityApiKeyInput = {
  /** Description informs on the purpose the key will be used for */
  description: Scalars['String']['input'];
  /**
   * Expiration date in YYYY-MM-DD format. API keys can only be added for up to 1 year from the date of creation.
   *
   * An attempt to add an API key with expiration date later than 1 year from the date of creation will be rejected.
   */
  expirationDate: Scalars['String']['input'];
  /** The list of roles that can be added by MSP is limited, for more granular access the Klarity API can be used to add API keys */
  role: KlarityApiKeyRole;
};

export type AddMspAccount = {
  admins: Array<AddAdmin>;
  name: Scalars['String']['input'];
  products: AddMspAccountProducts;
};

export type AddMspAccountProducts = {
  fleetControl: AddMspProductFleetControl;
  imageFactory: AddMspProductImageFactory;
  klarity: AddMspProductKlarity;
};

export type AddMspProductFleetControl = {
  enabled: Scalars['Boolean']['input'];
  instanceLocations: Array<FleetControlInstanceLocation>;
  regions: Array<Scalars['String']['input']>;
};

export type AddMspProductImageFactory = {
  enabled: Scalars['Boolean']['input'];
  /** @deprecated Not supported. */
  instanceLocations?: InputMaybe<Array<ImageFactoryInstanceLocation>>;
  operatingSystems: Array<ImageFactoryOperatingSystem>;
  providers: Array<ImageFactoryProvider>;
};

export type AddMspProductKlarity = {
  enabled: Scalars['Boolean']['input'];
  features: Array<KlarityFeatures>;
  instanceLocations: Array<KlarityInstanceLocation>;
  modes: Array<TenantMode>;
};

export type AddOrganization = {
  admins: Array<AddAdmin>;
  fleetControlTenants: Array<AddFleetControlTenant>;
  imageFactoryTenants: Array<AddImageFactoryTenant>;
  klarityCoreTenants: Array<AddOrganizationTenant>;
  mspAccountId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddOrganizationTenant = {
  defaultCurrency: Currency;
  /** Indicate whether the tenant will have the manual drift allocation resolving feature enabled or disabled */
  driftsStatus?: InputMaybe<KlarityTenantDriftsStatusInput>;
  /**
   * Indicates whether the tenant gets the Lite version with limited features
   *
   * isLite defaults to false if not provided (not required as that would be a breaking change for Overlay)
   */
  isLite?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['EmailAddress']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  surname: Scalars['String']['output'];
};

export type ApiKey = {
  /** Date of the creation of the key */
  createdAt: Scalars['String']['output'];
  /** Email of the user that has created the key */
  createdBy: Scalars['EmailAddress']['output'];
  /** Information regarding the use of the key */
  description: Scalars['String']['output'];
  /** API keys are of the following format: `{prefix}.{secret}`. Prefix is the first part, used to identify the key. */
  prefix: Scalars['ID']['output'];
};

/** A set of attributes, describing an existing api key. The secret part of the key is no longer available for the user. */
export type ApiKeyAttributes = ApiKey & {
  __typename?: 'ApiKeyAttributes';
  /** Date of the creation of the key */
  createdAt: Scalars['String']['output'];
  /** Email of the user that has created the key */
  createdBy: Scalars['EmailAddress']['output'];
  /** Information regarding the use of the key */
  description: Scalars['String']['output'];
  /** API keys are of the following format: `{prefix}.{secret}`. Prefix is the first part, used to identify the key. */
  prefix: Scalars['ID']['output'];
};

/** An api key secret, passed in the `key` field for the user to save, along with it's attributes. */
export type ApiKeySecret = ApiKey & {
  __typename?: 'ApiKeySecret';
  /** Date of the creation of the key */
  createdAt: Scalars['String']['output'];
  /** Email of the user that has created the key */
  createdBy: Scalars['EmailAddress']['output'];
  /** Information regarding the use of the key */
  description: Scalars['String']['output'];
  /** Key, formatted for use with the API using an x-api-key header */
  key: Scalars['String']['output'];
  /** API keys are of the following format: `{prefix}.{secret}`. Prefix is the first part, used to identify the key. */
  prefix: Scalars['ID']['output'];
};

export type AvailableAccounts = {
  __typename?: 'AvailableAccounts';
  /** Accounts which are available to the MSP Panel Administrator */
  accounts: Array<Scalars['String']['output']>;
  /** Denotes the role this administrator has */
  role: Role;
};

export type CloudCosts = {
  __typename?: 'CloudCosts';
  /** Average cost per month for current year, excluding the ongoing month and months with zero cost in calculations */
  averageMonthlyCostCurrentYear: Scalars['String']['output'];
  currentMonth: Scalars['String']['output'];
  /** @deprecated not displayed on the dashboard */
  forecast: Scalars['String']['output'];
  previousMonth: Scalars['String']['output'];
  /** provider indicates the provider for which costs are provided */
  provider: Provider;
};

export type CostAllocation = {
  __typename?: 'CostAllocation';
  allocated: Scalars['String']['output'];
  unallocated: Scalars['String']['output'];
};

export type CostSummary = {
  __typename?: 'CostSummary';
  /** Average cost per month for current year, excluding the ongoing month and months with zero cost in calculations */
  averageMonthlyCostCurrentYear: Scalars['String']['output'];
  /** Cost for current month */
  currentMonth: Scalars['String']['output'];
  /** Forecast cost for current month */
  forecast: Scalars['String']['output'];
  /** Cost for previous month */
  previousMonth: Scalars['String']['output'];
  /** Total cost since the beginning of year */
  totalCostCurrentYear: Scalars['String']['output'];
};

export type Currency =
  | 'DKK'
  | 'EUR'
  | 'GBP'
  | 'NOK'
  | 'SEK'
  | 'USD';

export type DashboardResponse = {
  __typename?: 'DashboardResponse';
  accountStatuses: Array<AccountStatuses>;
  cloudsCosts: Array<CloudCosts>;
  costAllocation: CostAllocation;
  costSummary: CostSummary;
  currency: Scalars['String']['output'];
  driftsStatus: KlarityTenantDriftsStatus;
  kpi?: Maybe<Kpi>;
  reservationsRecommendationsSummary: ReservationsRecommendationsSummary;
  savingsSuggestions: SavingsSuggestionsSummary;
};

export type EndOfLifeRelease = {
  __typename?: 'EndOfLifeRelease';
  endOfLifeDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FleetControlInstanceLocation =
  | 'EU'
  | 'UK'
  | 'US';

export type FleetControlTenant = {
  __typename?: 'FleetControlTenant';
  adminEmails: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  location: FleetControlTenantLocation;
  name: Scalars['String']['output'];
  regions: Array<Scalars['String']['output']>;
};

export type FleetControlTenantLocation =
  | 'EU'
  | 'UK'
  | 'US';

export type ImageFactoryDashboardResponse = {
  __typename?: 'ImageFactoryDashboardResponse';
  buildingSuccessRate: Scalars['String']['output'];
  cloudAccountsCount: Scalars['String']['output'];
  endOfLifeTemplatesCount: Scalars['String']['output'];
  imageTemplatesCount: Scalars['String']['output'];
  operatingSystemsCount: Scalars['String']['output'];
  statsByCloudProvider: Array<ImageFactoryStatsByCloud>;
};

export type ImageFactoryInstanceLocation =
  | 'EU';

export type ImageFactoryOperatingSystem =
  | 'FAMILY_AMAZON'
  | 'FAMILY_CENTOS'
  | 'FAMILY_ORACLE_LINUX'
  | 'FAMILY_REDHAT'
  | 'FAMILY_SUSE'
  | 'FAMILY_UBUNTU'
  | 'FAMILY_WINDOWS';

export type ImageFactoryProvider =
  | 'AWS'
  | 'AWS_CHINA'
  | 'AZURE'
  | 'AZURE_CHINA'
  | 'GCP'
  | 'IBMCLOUD'
  | 'VMWARE';

export type ImageFactoryStatsByCloud = {
  __typename?: 'ImageFactoryStatsByCloud';
  accountsWithoutCredentials: Scalars['String']['output'];
  connectedAccounts: Scalars['String']['output'];
  provider: ImageFactoryProvider;
  stats: Array<OperatingSystemStats>;
};

export type ImageFactoryTenant = {
  __typename?: 'ImageFactoryTenant';
  /** Dashboard contains mocked data for now */
  dashboard?: Maybe<ImageFactoryDashboardResponse>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  operatingSystems: Array<ImageFactoryOperatingSystem>;
  providers: Array<ImageFactoryProvider>;
};

export type KlarityApiKey = {
  /** Describes what permissions the key has */
  access: KlarityApiKeyAccess;
  /** Date of the creation of the key */
  createdAt: Scalars['String']['output'];
  /** Email of the user that has created the key, or id of the key that created the key */
  createdBy: KlarityPrincipal;
  /** Information regarding the use of the key */
  description: Scalars['String']['output'];
  /** Date of the key expiration, in RFC3339 format */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Klarity API keys follow the following format: "{id}/{secret}". Id is the first part, used to identify the key. */
  id: Scalars['ID']['output'];
  /** If true, the key was created using MSP Panel, otherwise it was created in Klarity itself */
  isCreatedByMSP: Scalars['Boolean']['output'];
};

export type KlarityApiKeyAccess = {
  __typename?: 'KlarityApiKeyAccess';
  /** This field is only defined if the role of the user/access key is `TEAM_LEAD` */
  applicationsWithNames?: Maybe<Array<KlarityApplication>>;
  role: KlarityRole;
};

export type KlarityApiKeyAttributes = KlarityApiKey & {
  __typename?: 'KlarityApiKeyAttributes';
  /** Describes what permissions the key has */
  access: KlarityApiKeyAccess;
  /** Date of the creation of the key */
  createdAt: Scalars['String']['output'];
  /** Email of the user that has created the key, or id of the key that created the key */
  createdBy: KlarityPrincipal;
  /** Information regarding the use of the key */
  description: Scalars['String']['output'];
  /** Date of the key expiration, in RFC3339 format */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Klarity API keys follow the following format: "{id}/{secret}". Id is the first part, used to identify the key. */
  id: Scalars['ID']['output'];
  /** If true, the key was created using MSP Panel, otherwise it was created in Klarity itself */
  isCreatedByMSP: Scalars['Boolean']['output'];
};

export type KlarityApiKeyRole =
  | 'ADMIN'
  | 'READ_ONLY';

export type KlarityApiKeySecret = KlarityApiKey & {
  __typename?: 'KlarityApiKeySecret';
  /** Describes what permissions the key has */
  access: KlarityApiKeyAccess;
  /** Date of the creation of the key */
  createdAt: Scalars['String']['output'];
  /** Email of the user that has created the key, or id of the key that created the key */
  createdBy: KlarityPrincipal;
  /** Information regarding the use of the key */
  description: Scalars['String']['output'];
  /** Date of the key expiration, in RFC3339 format */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Klarity API keys follow the following format: "{id}/{secret}". Id is the first part, used to identify the key. */
  id: Scalars['ID']['output'];
  /** If true, the key was created using MSP Panel, otherwise it was created in Klarity itself */
  isCreatedByMSP: Scalars['Boolean']['output'];
  /** Key, formatted for use with the API using an x-api-key header, contains both the id and the secret part of the key. */
  key: Scalars['String']['output'];
};

export type KlarityApplication = {
  __typename?: 'KlarityApplication';
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nid: Scalars['ID']['output'];
};

export type KlarityFeatures =
  | 'ARCHIVE'
  | 'CARBON_EMISSION'
  | 'EXTERNAL_INTEGRATIONS'
  | 'INTEGRATION_PLUGINS'
  | 'KPIS'
  | 'RESERVATIONS_AND_COMMITMENTS'
  | 'SAVING_SUGGESTIONS'
  | 'WORKFLOWS';

export type KlarityInstanceLocation =
  | 'EU'
  | 'UK'
  | 'US';

export type KlarityPrincipal = KlarityPrincipalEmail | KlarityPrincipalKey | KlarityPrincipalOther;

export type KlarityPrincipalEmail = {
  __typename?: 'KlarityPrincipalEmail';
  email: Scalars['EmailAddress']['output'];
};

export type KlarityPrincipalKey = {
  __typename?: 'KlarityPrincipalKey';
  id: Scalars['ID']['output'];
};

/** KlarityPrincipalOther is a different value which doesn't respect the 'principal' definition */
export type KlarityPrincipalOther = {
  __typename?: 'KlarityPrincipalOther';
  value: Scalars['String']['output'];
};

export type KlarityRole =
  | 'ADMIN'
  | 'READ_ONLY'
  | 'TEAM_LEAD';

export type KlarityTenantDriftsStatus =
  | 'DISABLED'
  | 'ENABLED';

/** Defines whether Klarity drifts feature is enabled or not. */
export type KlarityTenantDriftsStatusInput =
  | 'DISABLED'
  | 'ENABLED';

export type Kpi = {
  __typename?: 'Kpi';
  costAllocationCoverage: KpiDetails;
  nonProdHours: KpiDetails;
  overallWaste: KpiDetails;
};

export type KpiDetails = {
  __typename?: 'KpiDetails';
  /** measureValue is the different thing for each KPI thats measured, e.g. totalHours, allocation or waste */
  measureValue: Scalars['String']['output'];
  /** goal of the current target, if present, if not present it's going to be `-` */
  targetGoal: Scalars['String']['output'];
  /** the name of the target, if not present, will be `-` */
  targetName: Scalars['String']['output'];
  /** value is the value of the KPI */
  value: Scalars['String']['output'];
};

/** MSP Account entity */
export type MspAccount = {
  __typename?: 'MSPAccount';
  admins: Array<Admin>;
  apiKeys: Array<ApiKeyAttributes>;
  creationDate: Scalars['String']['output'];
  deletionRequest: MspAccountDeletionRequest;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** a list of all organizations which are contained within the account */
  organizations: Array<Organization>;
  products: MspAccountProducts;
  status: MspAccountStatus;
};

export type MspAccountDeletionRequest = {
  __typename?: 'MSPAccountDeletionRequest';
  requestDeletionDate?: Maybe<Scalars['String']['output']>;
  requestingUserIdentity?: Maybe<Scalars['String']['output']>;
};

export type MspAccountFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** List of available products */
export type MspAccountProducts = {
  __typename?: 'MSPAccountProducts';
  fleetControl: MspProductFleetControl;
  imageFactory: MspProductImageFactory;
  klarity: MspProductKlarity;
};

/** Input for MSP Account List. */
export type MspAccountSearchSort = {
  field?: InputMaybe<MspAccountSearchSortField>;
  order?: InputMaybe<MspAccountSearchSortOrder>;
};

/** Search sorting fields denominates the field by which result data will be ordered. */
export type MspAccountSearchSortField =
  | 'CREATION_DATE'
  | 'IMAGE_FACTORY_ENABLED'
  | 'KLARITY_ENABLED'
  | 'NAME'
  | 'STATUS';

/** Search sorting order is used to differentiate between ascending 'ASC' and descending 'DSC' orders. */
export type MspAccountSearchSortOrder =
  | 'ASC'
  | 'DSC';

export type MspAccountStatus =
  | 'DISABLED'
  | 'ENABLED'
  | 'MARKED_FOR_DELETION';

export type MspAccountsResponse = {
  __typename?: 'MSPAccountsResponse';
  accounts?: Maybe<Array<MspAccount>>;
};

/** Settings for FleetControl Product */
export type MspProductFleetControl = {
  __typename?: 'MSPProductFleetControl';
  enabled: Scalars['Boolean']['output'];
  instanceLocations: Array<FleetControlInstanceLocation>;
  regions: Array<Scalars['String']['output']>;
};

/** Settings for ImageFactory Product */
export type MspProductImageFactory = {
  __typename?: 'MSPProductImageFactory';
  enabled: Scalars['Boolean']['output'];
  /** @deprecated Not supported. */
  instanceLocations?: Maybe<Array<ImageFactoryInstanceLocation>>;
  operatingSystems: Array<ImageFactoryOperatingSystem>;
  providers: Array<ImageFactoryProvider>;
};

/** Settings for MCA (Klarity) Product */
export type MspProductKlarity = {
  __typename?: 'MSPProductKlarity';
  enabled: Scalars['Boolean']['output'];
  features: Array<KlarityFeatures>;
  instanceLocations: Array<KlarityInstanceLocation>;
  modes: Array<TenantMode>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add an API key to a selected MSP Account, distinguished by the `accountId ` parameter.
   *
   * The API key can be used to access the api via an additional header, `x-api-key`. For now, API keys can only be created by users,
   * not using other API keys. Once the key is created, the secret part of the key is only visible right after the creation process,
   * using the `ApiKeySecretResponse` GraphQL type, it has to be saved by a user for further use and won't be shown again.
   */
  addApiKey: ApiKeySecret;
  addFleetControlTenant: Organization;
  addImageFactoryTenant: Organization;
  /**
   * Add an API key to a Klarity tenant inside an organization managed by MSP.
   *
   * For more information about Klarity API keys, refer to Klarity documentation.
   */
  addKlarityApiKey: KlarityApiKeySecret;
  addKlarityCoreTenant: Organization;
  /** Add a new MSP Account */
  addMSPAccount: MspAccount;
  addMSPAdmin: Admin;
  addOrganization: Organization;
  addOrganizationAdmin: Organization;
  onboardExistingFleetControlTenant: Organization;
  /**
   * This mutation is used to onboard tenants created directly in Klarity Core before Panel creation.
   *
   * WARNING: API key access has role MSP_ADMIN, while this mutation requires MSP_PANEL_ADMIN.
   * Change it locally to MSP_ADMIN when running script
   */
  onboardExistingKlarityCoreTenant: Organization;
  /** Remove an API key, revoking it's permissions for the account */
  removeApiKey: RemoveApiKeyResponse;
  removeFleetControlTenant: Organization;
  removeImageFactoryTenant: Organization;
  /**
   * Remove an API key from a Klarity tenant inside an organization managed by MSP.
   *
   * Only keys created via the MSP Panel can be removed this way. Keys created via Klarity itself can only be removed via Klarity or
   * the Klarity API, with sufficient permissions.
   */
  removeKlarityApiKey: RemoveKlarityApiKeyResponse;
  removeKlarityCoreTenant: Organization;
  /** Remove a MSP Account */
  removeMSPAccount: Scalars['Boolean']['output'];
  removeMSPAdmin?: Maybe<Scalars['Boolean']['output']>;
  removeOrganization: Scalars['Boolean']['output'];
  removeOrganizationAdmin: Organization;
  /**
   * Sync organization and tenant names for all organizations and tenants within the MSP account
   * Warning: This will overwrite tenant names and organization names in Multicloud Accelerator
   */
  syncTenantNamesWithMCA: Scalars['Boolean']['output'];
  updateFleetControlTenant: Organization;
  updateImageFactoryTenant: Organization;
  updateKlarityCoreTenant: Organization;
  /** Update an existing MSP Account */
  updateMSPAccount: MspAccount;
  updateMSPAdmin?: Maybe<Admin>;
  updateOrganization: Organization;
  updateOrganizationAdmin: Organization;
};


export type MutationAddApiKeyArgs = {
  accountId: Scalars['ID']['input'];
  input: AddApiKey;
};


export type MutationAddFleetControlTenantArgs = {
  input: AddFleetControlTenant;
  organizationId: Scalars['String']['input'];
};


export type MutationAddImageFactoryTenantArgs = {
  input: AddImageFactoryTenant;
  organizationId: Scalars['String']['input'];
};


export type MutationAddKlarityApiKeyArgs = {
  input: AddKlarityApiKeyInput;
  klarityTenantId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationAddKlarityCoreTenantArgs = {
  input: AddOrganizationTenant;
  mspAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationAddMspAccountArgs = {
  input: AddMspAccount;
};


export type MutationAddMspAdminArgs = {
  accountId: Scalars['String']['input'];
  input: AddAdmin;
};


export type MutationAddOrganizationArgs = {
  input: AddOrganization;
};


export type MutationAddOrganizationAdminArgs = {
  input: AddAdmin;
  mspAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationOnboardExistingFleetControlTenantArgs = {
  input: OnboardFleetControlTenant;
  organizationId: Scalars['String']['input'];
};


export type MutationOnboardExistingKlarityCoreTenantArgs = {
  input: OnboardOrganizationTenant;
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveApiKeyArgs = {
  prefix: Scalars['ID']['input'];
};


export type MutationRemoveFleetControlTenantArgs = {
  fleetControlTenantId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveImageFactoryTenantArgs = {
  imageFactoryTenantId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveKlarityApiKeyArgs = {
  keyPrefix: Scalars['ID']['input'];
  klarityTenantId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveKlarityCoreTenantArgs = {
  klarityCoreTenantId: Scalars['String']['input'];
  mspAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveMspAccountArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveMspAdminArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveOrganizationArgs = {
  id: Scalars['String']['input'];
  mspAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveOrganizationAdminArgs = {
  adminId: Scalars['String']['input'];
  mspAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSyncTenantNamesWithMcaArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateFleetControlTenantArgs = {
  input: UpdateFleetControlTenant;
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateImageFactoryTenantArgs = {
  input: UpdateOrganizationTenant;
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateKlarityCoreTenantArgs = {
  input: UpdateOrganizationTenant;
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateMspAccountArgs = {
  input: UpdateMspAccount;
};


export type MutationUpdateMspAdminArgs = {
  input: UpdateMspAdmin;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganization;
};


export type MutationUpdateOrganizationAdminArgs = {
  adminId: Scalars['String']['input'];
  input: UpdateOrganizationAdmin;
  mspAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};

export type OnboardFleetControlTenant = {
  adminEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fleetControlTenantId: Scalars['String']['input'];
  location: FleetControlTenantLocation;
};

export type OnboardOrganizationTenant = {
  defaultCurrency: Currency;
  id: Scalars['String']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OperatingSystemStats = {
  __typename?: 'OperatingSystemStats';
  /** @deprecated There can be multiple EOL releases in one family, use `endOfLifeReleases` instead */
  endOfLifeDate?: Maybe<Scalars['String']['output']>;
  endOfLifeReleases: Array<EndOfLifeRelease>;
  failedBuilds: Scalars['String']['output'];
  family: ImageFactoryOperatingSystem;
  /** @deprecated There can be multiple named EOL releases, use `name` in `endOfLifeReleases` instead */
  name: Scalars['String']['output'];
  successfulBuilds: Scalars['String']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  admins: Array<Admin>;
  creationDate: Scalars['String']['output'];
  fleetControlTenants: Array<FleetControlTenant>;
  id: Scalars['String']['output'];
  imageFactoryTenants: Array<ImageFactoryTenant>;
  klarityCoreTenants: Array<OrganizationTenant>;
  mspAccount: MspAccount;
  name: Scalars['String']['output'];
  status: OrganizationStatus;
};

export type OrganizationStatus =
  | 'DISABLED'
  | 'ENABLED';

export type OrganizationTenant = {
  __typename?: 'OrganizationTenant';
  apiKeys: Array<KlarityApiKeyAttributes>;
  dashboard?: Maybe<DashboardResponse>;
  dashboardV2?: Maybe<DashboardResponse>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isLite: Scalars['Boolean']['output'];
  location: OrganizationTenantLocation;
  name: Scalars['String']['output'];
};

export type OrganizationTenantLocation =
  | 'EU'
  | 'UK'
  | 'US';

export type Provider =
  | 'AWS'
  | 'AZURE'
  | 'GCP'
  | 'IBMCLOUD'
  | 'KUBERNETES'
  | 'OPENSHIFT'
  | 'VMWARE';

export type Query = {
  __typename?: 'Query';
  access: AvailableAccounts;
  mspAccount?: Maybe<MspAccount>;
  /** @deprecated moving to mspAccountsSearch */
  mspAccounts?: Maybe<MspAccountsResponse>;
  mspAccountsSearch: Array<MspAccount>;
  /** `organization` queries a single organization object, using it's `id` */
  organization?: Maybe<Organization>;
  /** `organizations` queries every organization for every msp account that the user has access to */
  organizations: Array<Organization>;
};


export type QueryMspAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryMspAccountsArgs = {
  filter?: InputMaybe<MspAccountFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<MspAccountSearchSort>;
};


export type QueryMspAccountsSearchArgs = {
  filter?: InputMaybe<MspAccountFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<MspAccountSearchSort>;
};


export type QueryOrganizationArgsOld = {
  id: Scalars['ID']['input'];
};

export type RemoveApiKeyResponse = {
  __typename?: 'RemoveApiKeyResponse';
  prefix: Scalars['ID']['output'];
};

export type RemoveKlarityApiKeyResponse = {
  __typename?: 'RemoveKlarityApiKeyResponse';
  id: Scalars['ID']['output'];
};

export type ReservationsRecommendationsSummary = {
  __typename?: 'ReservationsRecommendationsSummary';
  monthlySavings: Scalars['String']['output'];
  upfrontCost: Scalars['String']['output'];
  yearlySavings: Scalars['String']['output'];
};

export type Role =
  | 'MSP_ADMIN'
  | 'MSP_PANEL_ADMIN';

export type SavingsSuggestionsSummary = {
  __typename?: 'SavingsSuggestionsSummary';
  /** Total cost of resources marked as waste */
  potentialMonthlySavings: Scalars['String']['output'];
  /** Total estimated co2 emissions of the resources marked as waste */
  potentialMonthlySavingsCO2: Scalars['String']['output'];
};

export type TenantMode =
  | 'FULL'
  | 'LITE';

export type UpdateFleetControlTenant = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateMspAccount = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<UpdateMspAccountProducts>;
  status?: InputMaybe<MspAccountStatus>;
};

export type UpdateMspAccountProducts = {
  fleetControl?: InputMaybe<UpdateMspProductFleetControl>;
  imageFactory?: InputMaybe<UpdateMspProductImageFactory>;
  klarity?: InputMaybe<UpdateMspProductKlarity>;
};

export type UpdateMspAdmin = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMspProductFleetControl = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  instanceLocations?: InputMaybe<Array<FleetControlInstanceLocation>>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateMspProductImageFactory = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Not supported. */
  instanceLocations?: InputMaybe<Array<ImageFactoryInstanceLocation>>;
  operatingSystems?: InputMaybe<Array<ImageFactoryOperatingSystem>>;
  providers?: InputMaybe<Array<ImageFactoryProvider>>;
};

export type UpdateMspProductKlarity = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  features?: InputMaybe<Array<KlarityFeatures>>;
  instanceLocations?: InputMaybe<Array<KlarityInstanceLocation>>;
  modes?: InputMaybe<Array<TenantMode>>;
};

export type UpdateOrganization = {
  id: Scalars['String']['input'];
  /** @deprecated since `mspAccountId` is no longer needed to identify a single organization, and organizations cannot be moved between accounts */
  mspAccountId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatus>;
};

export type UpdateOrganizationAdmin = {
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationTenant = {
  driftsStatus?: InputMaybe<KlarityTenantDriftsStatusInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  /** Indicates whether the tenant gets the Lite version with limited features */
  isLite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdminFragment = { __typename?: 'Admin', id: string, name: string, surname: string, email: any };

export type AccessQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessQuery = { __typename?: 'Query', access: { __typename?: 'AvailableAccounts', accounts: Array<string>, role: Role } };

export type AccountStatusFragment = { __typename?: 'MSPAccount', status: MspAccountStatus, creationDate: string, deletionRequest: { __typename?: 'MSPAccountDeletionRequest', requestDeletionDate?: string | null, requestingUserIdentity?: string | null } };

export type MspAdminFragment = { __typename?: 'Admin', id: string, name: string, surname: string, email: any };

export type MspAccountQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MspAccountQuery = { __typename?: 'Query', mspAccount?: { __typename?: 'MSPAccount', id: string, name: string, status: MspAccountStatus, creationDate: string, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }>, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', enabled: boolean }, imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean }, fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean } }, apiKeys: Array<{ __typename?: 'ApiKeyAttributes', prefix: string, createdAt: string, description: string }>, deletionRequest: { __typename?: 'MSPAccountDeletionRequest', requestDeletionDate?: string | null, requestingUserIdentity?: string | null } } | null };

export type UpdateAccountAfterDeletionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UpdateAccountAfterDeletionQuery = { __typename?: 'Query', mspAccount?: { __typename?: 'MSPAccount', id: string, status: MspAccountStatus, creationDate: string, deletionRequest: { __typename?: 'MSPAccountDeletionRequest', requestDeletionDate?: string | null, requestingUserIdentity?: string | null } } | null };

export type KlarityProductSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type KlarityProductSettingsQuery = { __typename?: 'Query', mspAccount?: { __typename?: 'MSPAccount', id: string, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', enabled: boolean, instanceLocations: Array<KlarityInstanceLocation>, modes: Array<TenantMode> } } } | null };

export type ImageFactoryProductSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ImageFactoryProductSettingsQuery = { __typename?: 'Query', mspAccount?: { __typename?: 'MSPAccount', id: string, products: { __typename?: 'MSPAccountProducts', imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean, providers: Array<ImageFactoryProvider>, operatingSystems: Array<ImageFactoryOperatingSystem> } } } | null };

export type FleetControlProductSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FleetControlProductSettingsQuery = { __typename?: 'Query', mspAccount?: { __typename?: 'MSPAccount', id: string, products: { __typename?: 'MSPAccountProducts', fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean, instanceLocations: Array<FleetControlInstanceLocation>, regions: Array<string> } } } | null };

export type AddMspAdminMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  input: AddAdmin;
}>;


export type AddMspAdminMutation = { __typename?: 'Mutation', addMSPAdmin: { __typename?: 'Admin', id: string, name: string, surname: string, email: any } };

export type RemoveMspAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveMspAdminMutation = { __typename?: 'Mutation', removeMSPAdmin?: boolean | null };

export type UpdateMspAdminMutationVariables = Exact<{
  input: UpdateMspAdmin;
}>;


export type UpdateMspAdminMutation = { __typename?: 'Mutation', updateMSPAdmin?: { __typename?: 'Admin', id: string, name: string, surname: string, email: any } | null };

export type UpdateMspAccountMutationVariables = Exact<{
  input: UpdateMspAccount;
}>;


export type UpdateMspAccountMutation = { __typename?: 'Mutation', updateMSPAccount: { __typename?: 'MSPAccount', id: string, name: string } };

export type RemoveMspAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveMspAccountMutation = { __typename?: 'Mutation', removeMSPAccount: boolean };

export type UpdateKlaritySettingsMutationVariables = Exact<{
  input: UpdateMspAccount;
}>;


export type UpdateKlaritySettingsMutation = { __typename?: 'Mutation', updateMSPAccount: { __typename?: 'MSPAccount', id: string, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', enabled: boolean, instanceLocations: Array<KlarityInstanceLocation>, modes: Array<TenantMode> } } } };

export type UpdateImageFactorySettingsMutationVariables = Exact<{
  input: UpdateMspAccount;
}>;


export type UpdateImageFactorySettingsMutation = { __typename?: 'Mutation', updateMSPAccount: { __typename?: 'MSPAccount', id: string, products: { __typename?: 'MSPAccountProducts', imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean, providers: Array<ImageFactoryProvider>, operatingSystems: Array<ImageFactoryOperatingSystem> } } } };

export type UpdateFleetControlSettingsMutationVariables = Exact<{
  input: UpdateMspAccount;
}>;


export type UpdateFleetControlSettingsMutation = { __typename?: 'Mutation', updateMSPAccount: { __typename?: 'MSPAccount', id: string, products: { __typename?: 'MSPAccountProducts', fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean, instanceLocations: Array<FleetControlInstanceLocation>, regions: Array<string> } } } };

export type AddApiKeyMutationVariables = Exact<{
  input: AddApiKey;
  accountId: Scalars['ID']['input'];
}>;


export type AddApiKeyMutation = { __typename?: 'Mutation', addApiKey: { __typename?: 'ApiKeySecret', key: string, prefix: string, createdAt: string, description: string } };

export type RemoveApiKeyMutationVariables = Exact<{
  prefix: Scalars['ID']['input'];
}>;


export type RemoveApiKeyMutation = { __typename?: 'Mutation', removeApiKey: { __typename?: 'RemoveApiKeyResponse', prefix: string } };

export type FleetControlSettingsFragment = { __typename?: 'MSPProductFleetControl', enabled: boolean, instanceLocations: Array<FleetControlInstanceLocation>, regions: Array<string> };

export type ImageFactorySettingsFragment = { __typename?: 'MSPProductImageFactory', enabled: boolean, providers: Array<ImageFactoryProvider>, operatingSystems: Array<ImageFactoryOperatingSystem> };

export type KlarityProductSettingsFragment = { __typename?: 'MSPProductKlarity', enabled: boolean, instanceLocations: Array<KlarityInstanceLocation>, modes: Array<TenantMode> };

type ApiKeyRowApiKeyAttributesFragment = { __typename?: 'ApiKeyAttributes', prefix: string, createdAt: string, description: string };

type ApiKeyRowApiKeySecretFragment = { __typename?: 'ApiKeySecret', prefix: string, createdAt: string, description: string };

export type ApiKeyRowFragment = ApiKeyRowApiKeyAttributesFragment | ApiKeyRowApiKeySecretFragment;

export type ChangeAccountStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: MspAccountStatus;
}>;


export type ChangeAccountStatusMutation = { __typename?: 'Mutation', updateMSPAccount: { __typename?: 'MSPAccount', id: string, status: MspAccountStatus, deletionRequest: { __typename?: 'MSPAccountDeletionRequest', requestingUserIdentity?: string | null, requestDeletionDate?: string | null } } };

export type MspAccountsListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type MspAccountsListQuery = { __typename?: 'Query', mspAccountsSearch: Array<{ __typename?: 'MSPAccount', id: string, name: string, status: MspAccountStatus, creationDate: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, status: OrganizationStatus }>, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }>, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', enabled: boolean }, imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean }, fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean } } }> };

export type AccountListRowFragment = { __typename?: 'MSPAccount', name: string, status: MspAccountStatus, creationDate: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, status: OrganizationStatus }>, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }>, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', enabled: boolean }, imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean }, fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean } } };

export type OrganizationFragment = { __typename?: 'Organization', id: string, name: string, status: OrganizationStatus };

export type AddMspAccountMutationVariables = Exact<{
  input: AddMspAccount;
}>;


export type AddMspAccountMutation = { __typename?: 'Mutation', addMSPAccount: { __typename?: 'MSPAccount', id: string, name: string, status: MspAccountStatus, creationDate: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, status: OrganizationStatus }>, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }>, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', enabled: boolean }, imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean }, fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean } } } };

export type MspAccountSelectItemQueryVariables = Exact<{ [key: string]: never; }>;


export type MspAccountSelectItemQuery = { __typename?: 'Query', mspAccountsSearch: Array<{ __typename?: 'MSPAccount', name: string, id: string, status: MspAccountStatus, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', instanceLocations: Array<KlarityInstanceLocation>, enabled: boolean, modes: Array<TenantMode> }, imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean, providers: Array<ImageFactoryProvider>, operatingSystems: Array<ImageFactoryOperatingSystem> }, fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean, instanceLocations: Array<FleetControlInstanceLocation>, regions: Array<string> } } }> };

export type CreateOrganizationMutationVariables = Exact<{
  input: AddOrganization;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', addOrganization: { __typename?: 'Organization', id: string, name: string, creationDate: string, status: OrganizationStatus, mspAccount: { __typename?: 'MSPAccount', name: string, id: string }, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string }>, klarityCoreTenants: Array<{ __typename?: 'OrganizationTenant', id: string }>, imageFactoryTenants: Array<{ __typename?: 'ImageFactoryTenant', id: string }>, fleetControlTenants: Array<{ __typename?: 'FleetControlTenant', id: string }> } };

export type MspAccountSelectItemFragment = { __typename?: 'MSPAccount', name: string, id: string, status: MspAccountStatus, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', instanceLocations: Array<KlarityInstanceLocation>, enabled: boolean, modes: Array<TenantMode> }, imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean, providers: Array<ImageFactoryProvider>, operatingSystems: Array<ImageFactoryOperatingSystem> }, fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean, instanceLocations: Array<FleetControlInstanceLocation>, regions: Array<string> } } };

export type SummaryFragment = { __typename?: 'Organization', name: string, status: OrganizationStatus, creationDate: string, mspAccount: { __typename?: 'MSPAccount', name: string, id: string } };

export type ImageFactoryDashboardFragment = { __typename?: 'ImageFactoryDashboardResponse', buildingSuccessRate: string, cloudAccountsCount: string, endOfLifeTemplatesCount: string, imageTemplatesCount: string, operatingSystemsCount: string, statsByCloudProvider: Array<{ __typename?: 'ImageFactoryStatsByCloud', accountsWithoutCredentials: string, connectedAccounts: string, provider: ImageFactoryProvider, stats: Array<{ __typename?: 'OperatingSystemStats', failedBuilds: string, family: ImageFactoryOperatingSystem, successfulBuilds: string, endOfLifeReleases: Array<{ __typename?: 'EndOfLifeRelease', name: string, endOfLifeDate: string }> }> }> };

export type CostDetailsFragment = { __typename?: 'DashboardResponse', costSummary: { __typename?: 'CostSummary', currentMonth: string, previousMonth: string, averageMonthlyCostCurrentYear: string, totalCostCurrentYear: string } };

export type KpiDetailsFragment = { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string };

export type KpiFragment = { __typename?: 'DashboardResponse', kpi?: { __typename?: 'Kpi', costAllocationCoverage: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, nonProdHours: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, overallWaste: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string } } | null };

export type MetricsFragment = { __typename?: 'DashboardResponse', costAllocation: { __typename?: 'CostAllocation', allocated: string, unallocated: string }, reservationsRecommendationsSummary: { __typename?: 'ReservationsRecommendationsSummary', monthlySavings: string, upfrontCost: string, yearlySavings: string }, savingsSuggestions: { __typename?: 'SavingsSuggestionsSummary', potentialMonthlySavings: string, potentialMonthlySavingsCO2: string } };

export type ProvidersFragment = { __typename?: 'DashboardResponse', cloudsCosts: Array<{ __typename?: 'CloudCosts', provider: Provider, averageMonthlyCostCurrentYear: string, currentMonth: string, previousMonth: string }>, accountStatuses: Array<{ __typename?: 'AccountStatuses', active: string, inactive: string, discovered: string, provider: Provider }> };

export type KlarityDashboardFragment = { __typename?: 'DashboardResponse', currency: string, driftsStatus: KlarityTenantDriftsStatus, kpi?: { __typename?: 'Kpi', costAllocationCoverage: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, nonProdHours: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, overallWaste: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string } } | null, costAllocation: { __typename?: 'CostAllocation', allocated: string, unallocated: string }, reservationsRecommendationsSummary: { __typename?: 'ReservationsRecommendationsSummary', monthlySavings: string, upfrontCost: string, yearlySavings: string }, savingsSuggestions: { __typename?: 'SavingsSuggestionsSummary', potentialMonthlySavings: string, potentialMonthlySavingsCO2: string }, cloudsCosts: Array<{ __typename?: 'CloudCosts', provider: Provider, averageMonthlyCostCurrentYear: string, currentMonth: string, previousMonth: string }>, accountStatuses: Array<{ __typename?: 'AccountStatuses', active: string, inactive: string, discovered: string, provider: Provider }>, costSummary: { __typename?: 'CostSummary', currentMonth: string, previousMonth: string, averageMonthlyCostCurrentYear: string, totalCostCurrentYear: string } };

type ApiKeysKlarityApiKeyAttributesFragment = { __typename?: 'KlarityApiKeyAttributes', id: string, createdAt: string, description: string, expirationDate?: string | null, isCreatedByMSP: boolean, createdBy: { __typename?: 'KlarityPrincipalEmail', email: any } | { __typename?: 'KlarityPrincipalKey', id: string } | { __typename?: 'KlarityPrincipalOther', value: string }, access: { __typename?: 'KlarityApiKeyAccess', role: KlarityRole, applicationsWithNames?: Array<{ __typename?: 'KlarityApplication', displayName?: string | null, name?: string | null, nid: string }> | null } };

type ApiKeysKlarityApiKeySecretFragment = { __typename?: 'KlarityApiKeySecret', id: string, createdAt: string, description: string, expirationDate?: string | null, isCreatedByMSP: boolean, createdBy: { __typename?: 'KlarityPrincipalEmail', email: any } | { __typename?: 'KlarityPrincipalKey', id: string } | { __typename?: 'KlarityPrincipalOther', value: string }, access: { __typename?: 'KlarityApiKeyAccess', role: KlarityRole, applicationsWithNames?: Array<{ __typename?: 'KlarityApplication', displayName?: string | null, name?: string | null, nid: string }> | null } };

export type ApiKeysFragment = ApiKeysKlarityApiKeyAttributesFragment | ApiKeysKlarityApiKeySecretFragment;

export type OrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, status: OrganizationStatus, creationDate: string, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }>, mspAccount: { __typename?: 'MSPAccount', name: string, id: string } } | null };

export type OrganizationTenantsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isAdmin: Scalars['Boolean']['input'];
}>;


export type OrganizationTenantsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, status: OrganizationStatus, mspAccount: { __typename?: 'MSPAccount', id: string, products: { __typename?: 'MSPAccountProducts', klarity: { __typename?: 'MSPProductKlarity', enabled: boolean, instanceLocations: Array<KlarityInstanceLocation>, modes: Array<TenantMode> }, imageFactory: { __typename?: 'MSPProductImageFactory', enabled: boolean, operatingSystems: Array<ImageFactoryOperatingSystem>, providers: Array<ImageFactoryProvider> }, fleetControl: { __typename?: 'MSPProductFleetControl', enabled: boolean, instanceLocations: Array<FleetControlInstanceLocation>, regions: Array<string> } } }, klarityCoreTenants: Array<{ __typename?: 'OrganizationTenant', name: string, id: string, location: OrganizationTenantLocation, enabled: boolean, isLite: boolean, apiKeys: Array<{ __typename?: 'KlarityApiKeyAttributes', id: string, createdAt: string, description: string, expirationDate?: string | null, isCreatedByMSP: boolean, createdBy: { __typename?: 'KlarityPrincipalEmail', email: any } | { __typename?: 'KlarityPrincipalKey', id: string } | { __typename?: 'KlarityPrincipalOther', value: string }, access: { __typename?: 'KlarityApiKeyAccess', role: KlarityRole, applicationsWithNames?: Array<{ __typename?: 'KlarityApplication', displayName?: string | null, name?: string | null, nid: string }> | null } }>, dashboard?: { __typename?: 'DashboardResponse', currency: string, driftsStatus: KlarityTenantDriftsStatus, kpi?: { __typename?: 'Kpi', costAllocationCoverage: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, nonProdHours: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, overallWaste: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string } } | null, costAllocation: { __typename?: 'CostAllocation', allocated: string, unallocated: string }, reservationsRecommendationsSummary: { __typename?: 'ReservationsRecommendationsSummary', monthlySavings: string, upfrontCost: string, yearlySavings: string }, savingsSuggestions: { __typename?: 'SavingsSuggestionsSummary', potentialMonthlySavings: string, potentialMonthlySavingsCO2: string }, cloudsCosts: Array<{ __typename?: 'CloudCosts', provider: Provider, averageMonthlyCostCurrentYear: string, currentMonth: string, previousMonth: string }>, accountStatuses: Array<{ __typename?: 'AccountStatuses', active: string, inactive: string, discovered: string, provider: Provider }>, costSummary: { __typename?: 'CostSummary', currentMonth: string, previousMonth: string, averageMonthlyCostCurrentYear: string, totalCostCurrentYear: string } } | null, dashboardV2?: { __typename?: 'DashboardResponse', currency: string, driftsStatus: KlarityTenantDriftsStatus, kpi?: { __typename?: 'Kpi', costAllocationCoverage: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, nonProdHours: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string }, overallWaste: { __typename?: 'KpiDetails', measureValue: string, targetGoal: string, value: string } } | null, costAllocation: { __typename?: 'CostAllocation', allocated: string, unallocated: string }, reservationsRecommendationsSummary: { __typename?: 'ReservationsRecommendationsSummary', monthlySavings: string, upfrontCost: string, yearlySavings: string }, savingsSuggestions: { __typename?: 'SavingsSuggestionsSummary', potentialMonthlySavings: string, potentialMonthlySavingsCO2: string }, cloudsCosts: Array<{ __typename?: 'CloudCosts', provider: Provider, averageMonthlyCostCurrentYear: string, currentMonth: string, previousMonth: string }>, accountStatuses: Array<{ __typename?: 'AccountStatuses', active: string, inactive: string, discovered: string, provider: Provider }>, costSummary: { __typename?: 'CostSummary', currentMonth: string, previousMonth: string, averageMonthlyCostCurrentYear: string, totalCostCurrentYear: string } } | null }>, imageFactoryTenants: Array<{ __typename?: 'ImageFactoryTenant', name: string, id: string, operatingSystems: Array<ImageFactoryOperatingSystem>, providers: Array<ImageFactoryProvider>, enabled: boolean, dashboard?: { __typename?: 'ImageFactoryDashboardResponse', buildingSuccessRate: string, cloudAccountsCount: string, endOfLifeTemplatesCount: string, imageTemplatesCount: string, operatingSystemsCount: string, statsByCloudProvider: Array<{ __typename?: 'ImageFactoryStatsByCloud', accountsWithoutCredentials: string, connectedAccounts: string, provider: ImageFactoryProvider, stats: Array<{ __typename?: 'OperatingSystemStats', failedBuilds: string, family: ImageFactoryOperatingSystem, successfulBuilds: string, endOfLifeReleases: Array<{ __typename?: 'EndOfLifeRelease', name: string, endOfLifeDate: string }> }> }> } | null }>, fleetControlTenants: Array<{ __typename?: 'FleetControlTenant', name: string, id: string, location: FleetControlTenantLocation, enabled: boolean, regions: Array<string>, adminEmails: Array<string> }> } | null };

export type OrganizationAccountsQueryVariables = Exact<{
  filter?: InputMaybe<MspAccountFilter>;
}>;


export type OrganizationAccountsQuery = { __typename?: 'Query', mspAccountsSearch: Array<{ __typename?: 'MSPAccount', products: { __typename?: 'MSPAccountProducts', fleetControl: { __typename?: 'MSPProductFleetControl', regions: Array<string> } } }> };

export type AddOrganizationAdminMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input: AddAdmin;
}>;


export type AddOrganizationAdminMutation = { __typename?: 'Mutation', addOrganizationAdmin: { __typename?: 'Organization', id: string, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }> } };

export type RemoveOrganizationAdminMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  adminId: Scalars['String']['input'];
}>;


export type RemoveOrganizationAdminMutation = { __typename?: 'Mutation', removeOrganizationAdmin: { __typename?: 'Organization', id: string, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }> } };

export type UpdateOrganizationAdminMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  adminId: Scalars['String']['input'];
  input: UpdateOrganizationAdmin;
}>;


export type UpdateOrganizationAdminMutation = { __typename?: 'Mutation', updateOrganizationAdmin: { __typename?: 'Organization', id: string, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string, email: any }> } };

export type RemoveKlarityCoreTenantMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  klarityCoreTenantId: Scalars['String']['input'];
}>;


export type RemoveKlarityCoreTenantMutation = { __typename?: 'Mutation', removeKlarityCoreTenant: { __typename?: 'Organization', id: string, klarityCoreTenants: Array<{ __typename?: 'OrganizationTenant', name: string, id: string, location: OrganizationTenantLocation, enabled: boolean, isLite: boolean }> } };

export type AddKlarityCoreTenantMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input: AddOrganizationTenant;
}>;


export type AddKlarityCoreTenantMutation = { __typename?: 'Mutation', addKlarityCoreTenant: { __typename?: 'Organization', id: string, klarityCoreTenants: Array<{ __typename?: 'OrganizationTenant', name: string, id: string, location: OrganizationTenantLocation, enabled: boolean, isLite: boolean }> } };

export type UpdateKlarityCoreTenantMutationVariables = Exact<{
  input: UpdateOrganizationTenant;
  organizationId: Scalars['String']['input'];
}>;


export type UpdateKlarityCoreTenantMutation = { __typename?: 'Mutation', updateKlarityCoreTenant: { __typename?: 'Organization', id: string } };

export type RemoveImageFactoryTenantMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  imageFactoryTenantId: Scalars['String']['input'];
}>;


export type RemoveImageFactoryTenantMutation = { __typename?: 'Mutation', removeImageFactoryTenant: { __typename?: 'Organization', id: string, imageFactoryTenants: Array<{ __typename?: 'ImageFactoryTenant', name: string, id: string, operatingSystems: Array<ImageFactoryOperatingSystem>, providers: Array<ImageFactoryProvider>, enabled: boolean }> } };

export type AddImageFactoryTenantMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input: AddImageFactoryTenant;
}>;


export type AddImageFactoryTenantMutation = { __typename?: 'Mutation', addImageFactoryTenant: { __typename?: 'Organization', id: string, imageFactoryTenants: Array<{ __typename?: 'ImageFactoryTenant', name: string, id: string, operatingSystems: Array<ImageFactoryOperatingSystem>, providers: Array<ImageFactoryProvider>, enabled: boolean }> } };

export type UpdateImageFactoryTenantMutationVariables = Exact<{
  input: UpdateOrganizationTenant;
  organizationId: Scalars['String']['input'];
}>;


export type UpdateImageFactoryTenantMutation = { __typename?: 'Mutation', updateImageFactoryTenant: { __typename?: 'Organization', id: string } };

export type RemoveFleetControlTenantMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  fleetControlTenantId: Scalars['String']['input'];
}>;


export type RemoveFleetControlTenantMutation = { __typename?: 'Mutation', removeFleetControlTenant: { __typename?: 'Organization', id: string, fleetControlTenants: Array<{ __typename?: 'FleetControlTenant', name: string, id: string, location: FleetControlTenantLocation, enabled: boolean, regions: Array<string>, adminEmails: Array<string> }> } };

export type AddFleetControlTenantMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  input: AddFleetControlTenant;
}>;


export type AddFleetControlTenantMutation = { __typename?: 'Mutation', addFleetControlTenant: { __typename?: 'Organization', id: string, fleetControlTenants: Array<{ __typename?: 'FleetControlTenant', name: string, id: string, location: FleetControlTenantLocation, enabled: boolean, regions: Array<string>, adminEmails: Array<string> }> } };

export type UpdateFleetControlTenantMutationVariables = Exact<{
  input: UpdateFleetControlTenant;
  organizationId: Scalars['String']['input'];
}>;


export type UpdateFleetControlTenantMutation = { __typename?: 'Mutation', updateFleetControlTenant: { __typename?: 'Organization', id: string } };

export type ChangeOrganizationNameMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type ChangeOrganizationNameMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string } };

export type AddKlarityApiKeyMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  klarityTenantId: Scalars['ID']['input'];
  input: AddKlarityApiKeyInput;
}>;


export type AddKlarityApiKeyMutation = { __typename?: 'Mutation', addKlarityApiKey: { __typename?: 'KlarityApiKeySecret', key: string, id: string, createdAt: string, description: string, expirationDate?: string | null, isCreatedByMSP: boolean, createdBy: { __typename?: 'KlarityPrincipalEmail', email: any } | { __typename?: 'KlarityPrincipalKey', id: string } | { __typename?: 'KlarityPrincipalOther', value: string }, access: { __typename?: 'KlarityApiKeyAccess', role: KlarityRole, applicationsWithNames?: Array<{ __typename?: 'KlarityApplication', displayName?: string | null, name?: string | null, nid: string }> | null } } };

export type RemoveKlarityApiKeyMutationVariables = Exact<{
  klarityTenantId: Scalars['ID']['input'];
  keyPrefix: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type RemoveKlarityApiKeyMutation = { __typename?: 'Mutation', removeKlarityApiKey: { __typename?: 'RemoveKlarityApiKeyResponse', id: string } };

export type OrganizationRowFragment = { __typename?: 'Organization', id: string, name: string, creationDate: string, status: OrganizationStatus, mspAccount: { __typename?: 'MSPAccount', name: string, id: string }, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string }>, klarityCoreTenants: Array<{ __typename?: 'OrganizationTenant', id: string }>, imageFactoryTenants: Array<{ __typename?: 'ImageFactoryTenant', id: string }>, fleetControlTenants: Array<{ __typename?: 'FleetControlTenant', id: string }> };

export type OrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string, creationDate: string, status: OrganizationStatus, mspAccount: { __typename?: 'MSPAccount', name: string, id: string }, admins: Array<{ __typename?: 'Admin', id: string, name: string, surname: string }>, klarityCoreTenants: Array<{ __typename?: 'OrganizationTenant', id: string }>, imageFactoryTenants: Array<{ __typename?: 'ImageFactoryTenant', id: string }>, fleetControlTenants: Array<{ __typename?: 'FleetControlTenant', id: string }> }> };

export type FleetControlTenantFragment = { __typename?: 'FleetControlTenant', name: string, id: string, location: FleetControlTenantLocation, enabled: boolean, regions: Array<string>, adminEmails: Array<string> };

export type ImageFactoryTenantFragment = { __typename?: 'ImageFactoryTenant', name: string, id: string, operatingSystems: Array<ImageFactoryOperatingSystem>, providers: Array<ImageFactoryProvider>, enabled: boolean };

export type KlarityCoreTenantFragment = { __typename?: 'OrganizationTenant', name: string, id: string, location: OrganizationTenantLocation, enabled: boolean, isLite: boolean };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', removeOrganization: boolean };

export type ChangeOrganizationStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: OrganizationStatus;
}>;


export type ChangeOrganizationStatusMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, status: OrganizationStatus } };

export const AccountStatusFragmentDoc = gql`
    fragment AccountStatus on MSPAccount {
  status
  creationDate
  deletionRequest {
    requestDeletionDate
    requestingUserIdentity
  }
}
    `;
export const MspAdminFragmentDoc = gql`
    fragment MspAdmin on Admin {
  id
  name
  surname
  email
}
    `;
export const FleetControlSettingsFragmentDoc = gql`
    fragment FleetControlSettings on MSPProductFleetControl {
  enabled
  instanceLocations
  regions
}
    `;
export const ImageFactorySettingsFragmentDoc = gql`
    fragment ImageFactorySettings on MSPProductImageFactory {
  enabled
  providers
  operatingSystems
}
    `;
export const KlarityProductSettingsFragmentDoc = gql`
    fragment KlarityProductSettings on MSPProductKlarity {
  enabled
  instanceLocations
  modes
}
    `;
export const ApiKeyRowFragmentDoc = gql`
    fragment ApiKeyRow on ApiKey {
  prefix
  createdAt
  description
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on Organization {
  id
  name
  status
}
    `;
export const AdminFragmentDoc = gql`
    fragment Admin on Admin {
  id
  name
  surname
  email
}
    `;
export const AccountListRowFragmentDoc = gql`
    fragment AccountListRow on MSPAccount {
  name
  status
  creationDate
  organizations {
    ...Organization
  }
  admins {
    ...Admin
  }
  products {
    klarity {
      enabled
    }
    imageFactory {
      enabled
    }
    fleetControl {
      enabled
    }
  }
}
    ${OrganizationFragmentDoc}
${AdminFragmentDoc}`;
export const MspAccountSelectItemFragmentDoc = gql`
    fragment MspAccountSelectItem on MSPAccount {
  name
  id
  status
  products {
    klarity {
      instanceLocations
      enabled
      modes
    }
    imageFactory {
      enabled
      providers
      operatingSystems
    }
    fleetControl {
      enabled
      instanceLocations
      regions
    }
  }
}
    `;
export const SummaryFragmentDoc = gql`
    fragment Summary on Organization {
  name
  status
  creationDate
  mspAccount {
    name
    id
  }
}
    `;
export const ImageFactoryDashboardFragmentDoc = gql`
    fragment ImageFactoryDashboard on ImageFactoryDashboardResponse {
  buildingSuccessRate
  cloudAccountsCount
  endOfLifeTemplatesCount
  imageTemplatesCount
  operatingSystemsCount
  statsByCloudProvider {
    accountsWithoutCredentials
    connectedAccounts
    provider
    stats {
      failedBuilds
      family
      successfulBuilds
      endOfLifeReleases {
        name
        endOfLifeDate
      }
    }
  }
}
    `;
export const KpiDetailsFragmentDoc = gql`
    fragment KpiDetails on KpiDetails {
  measureValue
  targetGoal
  value
}
    `;
export const KpiFragmentDoc = gql`
    fragment Kpi on DashboardResponse {
  kpi {
    costAllocationCoverage {
      ...KpiDetails
    }
    nonProdHours {
      ...KpiDetails
    }
    overallWaste {
      ...KpiDetails
    }
  }
}
    ${KpiDetailsFragmentDoc}`;
export const MetricsFragmentDoc = gql`
    fragment Metrics on DashboardResponse {
  costAllocation {
    allocated
    unallocated
  }
  reservationsRecommendationsSummary {
    monthlySavings
    upfrontCost
    yearlySavings
  }
  savingsSuggestions {
    potentialMonthlySavings
    potentialMonthlySavingsCO2
  }
}
    `;
export const ProvidersFragmentDoc = gql`
    fragment Providers on DashboardResponse {
  cloudsCosts {
    provider
    averageMonthlyCostCurrentYear
    currentMonth
    previousMonth
  }
  accountStatuses {
    active
    inactive
    discovered
    provider
  }
}
    `;
export const CostDetailsFragmentDoc = gql`
    fragment CostDetails on DashboardResponse {
  costSummary {
    currentMonth
    previousMonth
    averageMonthlyCostCurrentYear
    totalCostCurrentYear
  }
}
    `;
export const KlarityDashboardFragmentDoc = gql`
    fragment KlarityDashboard on DashboardResponse {
  currency
  driftsStatus
  ...Kpi
  ...Metrics
  ...Providers
  ...CostDetails
}
    ${KpiFragmentDoc}
${MetricsFragmentDoc}
${ProvidersFragmentDoc}
${CostDetailsFragmentDoc}`;
export const ApiKeysFragmentDoc = gql`
    fragment ApiKeys on KlarityApiKey {
  id
  createdAt
  createdBy {
    ... on KlarityPrincipalEmail {
      email
    }
    ... on KlarityPrincipalKey {
      id
    }
    ... on KlarityPrincipalOther {
      value
    }
  }
  description
  expirationDate
  isCreatedByMSP
  access {
    role
    applicationsWithNames {
      displayName
      name
      nid
    }
  }
}
    `;
export const OrganizationRowFragmentDoc = gql`
    fragment OrganizationRow on Organization {
  id
  name
  mspAccount {
    name
    id
  }
  admins {
    id
    name
    surname
  }
  creationDate
  status
  klarityCoreTenants {
    id
  }
  imageFactoryTenants {
    id
  }
  fleetControlTenants {
    id
  }
}
    `;
export const FleetControlTenantFragmentDoc = gql`
    fragment FleetControlTenant on FleetControlTenant {
  name
  id
  location
  enabled
  regions
  adminEmails
}
    `;
export const ImageFactoryTenantFragmentDoc = gql`
    fragment ImageFactoryTenant on ImageFactoryTenant {
  name
  id
  operatingSystems
  providers
  enabled
}
    `;
export const KlarityCoreTenantFragmentDoc = gql`
    fragment KlarityCoreTenant on OrganizationTenant {
  name
  id
  location
  enabled
  isLite
}
    `;
export const AccessDocument = gql`
    query Access {
  access {
    accounts
    role
  }
}
    `;

/**
 * __useAccessQuery__
 *
 * To run a query within a React component, call `useAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessQuery(baseOptions?: Apollo.QueryHookOptions<AccessQuery, AccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessQuery, AccessQueryVariables>(AccessDocument, options);
      }
export function useAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessQuery, AccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessQuery, AccessQueryVariables>(AccessDocument, options);
        }
export function useAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessQuery, AccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessQuery, AccessQueryVariables>(AccessDocument, options);
        }
export type AccessQueryHookResult = ReturnType<typeof useAccessQuery>;
export type AccessLazyQueryHookResult = ReturnType<typeof useAccessLazyQuery>;
export type AccessSuspenseQueryHookResult = ReturnType<typeof useAccessSuspenseQuery>;
export type AccessQueryResult = Apollo.QueryResult<AccessQuery, AccessQueryVariables>;
export const MspAccountDocument = gql`
    query MSPAccount($id: String!) {
  mspAccount(id: $id) {
    id
    name
    admins {
      ...MspAdmin
    }
    ...AccountStatus
    products {
      klarity {
        enabled
      }
      imageFactory {
        enabled
      }
      fleetControl {
        enabled
      }
    }
    apiKeys {
      ...ApiKeyRow
    }
  }
}
    ${MspAdminFragmentDoc}
${AccountStatusFragmentDoc}
${ApiKeyRowFragmentDoc}`;

/**
 * __useMspAccountQuery__
 *
 * To run a query within a React component, call `useMspAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMspAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMspAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMspAccountQuery(baseOptions: Apollo.QueryHookOptions<MspAccountQuery, MspAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MspAccountQuery, MspAccountQueryVariables>(MspAccountDocument, options);
      }
export function useMspAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MspAccountQuery, MspAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MspAccountQuery, MspAccountQueryVariables>(MspAccountDocument, options);
        }
export function useMspAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MspAccountQuery, MspAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MspAccountQuery, MspAccountQueryVariables>(MspAccountDocument, options);
        }
export type MspAccountQueryHookResult = ReturnType<typeof useMspAccountQuery>;
export type MspAccountLazyQueryHookResult = ReturnType<typeof useMspAccountLazyQuery>;
export type MspAccountSuspenseQueryHookResult = ReturnType<typeof useMspAccountSuspenseQuery>;
export type MspAccountQueryResult = Apollo.QueryResult<MspAccountQuery, MspAccountQueryVariables>;
export const UpdateAccountAfterDeletionDocument = gql`
    query UpdateAccountAfterDeletion($id: String!) {
  mspAccount(id: $id) {
    id
    ...AccountStatus
  }
}
    ${AccountStatusFragmentDoc}`;

/**
 * __useUpdateAccountAfterDeletionQuery__
 *
 * To run a query within a React component, call `useUpdateAccountAfterDeletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountAfterDeletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateAccountAfterDeletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAccountAfterDeletionQuery(baseOptions: Apollo.QueryHookOptions<UpdateAccountAfterDeletionQuery, UpdateAccountAfterDeletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateAccountAfterDeletionQuery, UpdateAccountAfterDeletionQueryVariables>(UpdateAccountAfterDeletionDocument, options);
      }
export function useUpdateAccountAfterDeletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateAccountAfterDeletionQuery, UpdateAccountAfterDeletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateAccountAfterDeletionQuery, UpdateAccountAfterDeletionQueryVariables>(UpdateAccountAfterDeletionDocument, options);
        }
export function useUpdateAccountAfterDeletionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateAccountAfterDeletionQuery, UpdateAccountAfterDeletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateAccountAfterDeletionQuery, UpdateAccountAfterDeletionQueryVariables>(UpdateAccountAfterDeletionDocument, options);
        }
export type UpdateAccountAfterDeletionQueryHookResult = ReturnType<typeof useUpdateAccountAfterDeletionQuery>;
export type UpdateAccountAfterDeletionLazyQueryHookResult = ReturnType<typeof useUpdateAccountAfterDeletionLazyQuery>;
export type UpdateAccountAfterDeletionSuspenseQueryHookResult = ReturnType<typeof useUpdateAccountAfterDeletionSuspenseQuery>;
export type UpdateAccountAfterDeletionQueryResult = Apollo.QueryResult<UpdateAccountAfterDeletionQuery, UpdateAccountAfterDeletionQueryVariables>;
export const KlarityProductSettingsDocument = gql`
    query KlarityProductSettings($id: String!) {
  mspAccount(id: $id) {
    id
    products {
      klarity {
        ...KlarityProductSettings
      }
    }
  }
}
    ${KlarityProductSettingsFragmentDoc}`;

/**
 * __useKlarityProductSettingsQuery__
 *
 * To run a query within a React component, call `useKlarityProductSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKlarityProductSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKlarityProductSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKlarityProductSettingsQuery(baseOptions: Apollo.QueryHookOptions<KlarityProductSettingsQuery, KlarityProductSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KlarityProductSettingsQuery, KlarityProductSettingsQueryVariables>(KlarityProductSettingsDocument, options);
      }
export function useKlarityProductSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KlarityProductSettingsQuery, KlarityProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KlarityProductSettingsQuery, KlarityProductSettingsQueryVariables>(KlarityProductSettingsDocument, options);
        }
export function useKlarityProductSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KlarityProductSettingsQuery, KlarityProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KlarityProductSettingsQuery, KlarityProductSettingsQueryVariables>(KlarityProductSettingsDocument, options);
        }
export type KlarityProductSettingsQueryHookResult = ReturnType<typeof useKlarityProductSettingsQuery>;
export type KlarityProductSettingsLazyQueryHookResult = ReturnType<typeof useKlarityProductSettingsLazyQuery>;
export type KlarityProductSettingsSuspenseQueryHookResult = ReturnType<typeof useKlarityProductSettingsSuspenseQuery>;
export type KlarityProductSettingsQueryResult = Apollo.QueryResult<KlarityProductSettingsQuery, KlarityProductSettingsQueryVariables>;
export const ImageFactoryProductSettingsDocument = gql`
    query ImageFactoryProductSettings($id: String!) {
  mspAccount(id: $id) {
    id
    products {
      imageFactory {
        ...ImageFactorySettings
      }
    }
  }
}
    ${ImageFactorySettingsFragmentDoc}`;

/**
 * __useImageFactoryProductSettingsQuery__
 *
 * To run a query within a React component, call `useImageFactoryProductSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageFactoryProductSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageFactoryProductSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImageFactoryProductSettingsQuery(baseOptions: Apollo.QueryHookOptions<ImageFactoryProductSettingsQuery, ImageFactoryProductSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageFactoryProductSettingsQuery, ImageFactoryProductSettingsQueryVariables>(ImageFactoryProductSettingsDocument, options);
      }
export function useImageFactoryProductSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageFactoryProductSettingsQuery, ImageFactoryProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageFactoryProductSettingsQuery, ImageFactoryProductSettingsQueryVariables>(ImageFactoryProductSettingsDocument, options);
        }
export function useImageFactoryProductSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImageFactoryProductSettingsQuery, ImageFactoryProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImageFactoryProductSettingsQuery, ImageFactoryProductSettingsQueryVariables>(ImageFactoryProductSettingsDocument, options);
        }
export type ImageFactoryProductSettingsQueryHookResult = ReturnType<typeof useImageFactoryProductSettingsQuery>;
export type ImageFactoryProductSettingsLazyQueryHookResult = ReturnType<typeof useImageFactoryProductSettingsLazyQuery>;
export type ImageFactoryProductSettingsSuspenseQueryHookResult = ReturnType<typeof useImageFactoryProductSettingsSuspenseQuery>;
export type ImageFactoryProductSettingsQueryResult = Apollo.QueryResult<ImageFactoryProductSettingsQuery, ImageFactoryProductSettingsQueryVariables>;
export const FleetControlProductSettingsDocument = gql`
    query FleetControlProductSettings($id: String!) {
  mspAccount(id: $id) {
    id
    products {
      fleetControl {
        ...FleetControlSettings
      }
    }
  }
}
    ${FleetControlSettingsFragmentDoc}`;

/**
 * __useFleetControlProductSettingsQuery__
 *
 * To run a query within a React component, call `useFleetControlProductSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetControlProductSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetControlProductSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFleetControlProductSettingsQuery(baseOptions: Apollo.QueryHookOptions<FleetControlProductSettingsQuery, FleetControlProductSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FleetControlProductSettingsQuery, FleetControlProductSettingsQueryVariables>(FleetControlProductSettingsDocument, options);
      }
export function useFleetControlProductSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FleetControlProductSettingsQuery, FleetControlProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FleetControlProductSettingsQuery, FleetControlProductSettingsQueryVariables>(FleetControlProductSettingsDocument, options);
        }
export function useFleetControlProductSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FleetControlProductSettingsQuery, FleetControlProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FleetControlProductSettingsQuery, FleetControlProductSettingsQueryVariables>(FleetControlProductSettingsDocument, options);
        }
export type FleetControlProductSettingsQueryHookResult = ReturnType<typeof useFleetControlProductSettingsQuery>;
export type FleetControlProductSettingsLazyQueryHookResult = ReturnType<typeof useFleetControlProductSettingsLazyQuery>;
export type FleetControlProductSettingsSuspenseQueryHookResult = ReturnType<typeof useFleetControlProductSettingsSuspenseQuery>;
export type FleetControlProductSettingsQueryResult = Apollo.QueryResult<FleetControlProductSettingsQuery, FleetControlProductSettingsQueryVariables>;
export const AddMspAdminDocument = gql`
    mutation AddMSPAdmin($accountId: String!, $input: AddAdmin!) {
  addMSPAdmin(accountId: $accountId, input: $input) {
    ...MspAdmin
  }
}
    ${MspAdminFragmentDoc}`;
export type AddMspAdminMutationFn = Apollo.MutationFunction<AddMspAdminMutation, AddMspAdminMutationVariables>;

/**
 * __useAddMspAdminMutation__
 *
 * To run a mutation, you first call `useAddMspAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMspAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMspAdminMutation, { data, loading, error }] = useAddMspAdminMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMspAdminMutation(baseOptions?: Apollo.MutationHookOptions<AddMspAdminMutation, AddMspAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMspAdminMutation, AddMspAdminMutationVariables>(AddMspAdminDocument, options);
      }
export type AddMspAdminMutationHookResult = ReturnType<typeof useAddMspAdminMutation>;
export type AddMspAdminMutationResult = Apollo.MutationResult<AddMspAdminMutation>;
export type AddMspAdminMutationOptions = Apollo.BaseMutationOptions<AddMspAdminMutation, AddMspAdminMutationVariables>;
export const RemoveMspAdminDocument = gql`
    mutation RemoveMSPAdmin($id: String!) {
  removeMSPAdmin(id: $id)
}
    `;
export type RemoveMspAdminMutationFn = Apollo.MutationFunction<RemoveMspAdminMutation, RemoveMspAdminMutationVariables>;

/**
 * __useRemoveMspAdminMutation__
 *
 * To run a mutation, you first call `useRemoveMspAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMspAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMspAdminMutation, { data, loading, error }] = useRemoveMspAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMspAdminMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMspAdminMutation, RemoveMspAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMspAdminMutation, RemoveMspAdminMutationVariables>(RemoveMspAdminDocument, options);
      }
export type RemoveMspAdminMutationHookResult = ReturnType<typeof useRemoveMspAdminMutation>;
export type RemoveMspAdminMutationResult = Apollo.MutationResult<RemoveMspAdminMutation>;
export type RemoveMspAdminMutationOptions = Apollo.BaseMutationOptions<RemoveMspAdminMutation, RemoveMspAdminMutationVariables>;
export const UpdateMspAdminDocument = gql`
    mutation UpdateMSPAdmin($input: UpdateMSPAdmin!) {
  updateMSPAdmin(input: $input) {
    ...MspAdmin
  }
}
    ${MspAdminFragmentDoc}`;
export type UpdateMspAdminMutationFn = Apollo.MutationFunction<UpdateMspAdminMutation, UpdateMspAdminMutationVariables>;

/**
 * __useUpdateMspAdminMutation__
 *
 * To run a mutation, you first call `useUpdateMspAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMspAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMspAdminMutation, { data, loading, error }] = useUpdateMspAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMspAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMspAdminMutation, UpdateMspAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMspAdminMutation, UpdateMspAdminMutationVariables>(UpdateMspAdminDocument, options);
      }
export type UpdateMspAdminMutationHookResult = ReturnType<typeof useUpdateMspAdminMutation>;
export type UpdateMspAdminMutationResult = Apollo.MutationResult<UpdateMspAdminMutation>;
export type UpdateMspAdminMutationOptions = Apollo.BaseMutationOptions<UpdateMspAdminMutation, UpdateMspAdminMutationVariables>;
export const UpdateMspAccountDocument = gql`
    mutation UpdateMSPAccount($input: UpdateMSPAccount!) {
  updateMSPAccount(input: $input) {
    id
    name
  }
}
    `;
export type UpdateMspAccountMutationFn = Apollo.MutationFunction<UpdateMspAccountMutation, UpdateMspAccountMutationVariables>;

/**
 * __useUpdateMspAccountMutation__
 *
 * To run a mutation, you first call `useUpdateMspAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMspAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMspAccountMutation, { data, loading, error }] = useUpdateMspAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMspAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMspAccountMutation, UpdateMspAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMspAccountMutation, UpdateMspAccountMutationVariables>(UpdateMspAccountDocument, options);
      }
export type UpdateMspAccountMutationHookResult = ReturnType<typeof useUpdateMspAccountMutation>;
export type UpdateMspAccountMutationResult = Apollo.MutationResult<UpdateMspAccountMutation>;
export type UpdateMspAccountMutationOptions = Apollo.BaseMutationOptions<UpdateMspAccountMutation, UpdateMspAccountMutationVariables>;
export const RemoveMspAccountDocument = gql`
    mutation RemoveMSPAccount($id: String!) {
  removeMSPAccount(id: $id)
}
    `;
export type RemoveMspAccountMutationFn = Apollo.MutationFunction<RemoveMspAccountMutation, RemoveMspAccountMutationVariables>;

/**
 * __useRemoveMspAccountMutation__
 *
 * To run a mutation, you first call `useRemoveMspAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMspAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMspAccountMutation, { data, loading, error }] = useRemoveMspAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMspAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMspAccountMutation, RemoveMspAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMspAccountMutation, RemoveMspAccountMutationVariables>(RemoveMspAccountDocument, options);
      }
export type RemoveMspAccountMutationHookResult = ReturnType<typeof useRemoveMspAccountMutation>;
export type RemoveMspAccountMutationResult = Apollo.MutationResult<RemoveMspAccountMutation>;
export type RemoveMspAccountMutationOptions = Apollo.BaseMutationOptions<RemoveMspAccountMutation, RemoveMspAccountMutationVariables>;
export const UpdateKlaritySettingsDocument = gql`
    mutation UpdateKlaritySettings($input: UpdateMSPAccount!) {
  updateMSPAccount(input: $input) {
    id
    products {
      klarity {
        ...KlarityProductSettings
      }
    }
  }
}
    ${KlarityProductSettingsFragmentDoc}`;
export type UpdateKlaritySettingsMutationFn = Apollo.MutationFunction<UpdateKlaritySettingsMutation, UpdateKlaritySettingsMutationVariables>;

/**
 * __useUpdateKlaritySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateKlaritySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKlaritySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKlaritySettingsMutation, { data, loading, error }] = useUpdateKlaritySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKlaritySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKlaritySettingsMutation, UpdateKlaritySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKlaritySettingsMutation, UpdateKlaritySettingsMutationVariables>(UpdateKlaritySettingsDocument, options);
      }
export type UpdateKlaritySettingsMutationHookResult = ReturnType<typeof useUpdateKlaritySettingsMutation>;
export type UpdateKlaritySettingsMutationResult = Apollo.MutationResult<UpdateKlaritySettingsMutation>;
export type UpdateKlaritySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateKlaritySettingsMutation, UpdateKlaritySettingsMutationVariables>;
export const UpdateImageFactorySettingsDocument = gql`
    mutation UpdateImageFactorySettings($input: UpdateMSPAccount!) {
  updateMSPAccount(input: $input) {
    id
    products {
      imageFactory {
        ...ImageFactorySettings
      }
    }
  }
}
    ${ImageFactorySettingsFragmentDoc}`;
export type UpdateImageFactorySettingsMutationFn = Apollo.MutationFunction<UpdateImageFactorySettingsMutation, UpdateImageFactorySettingsMutationVariables>;

/**
 * __useUpdateImageFactorySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateImageFactorySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageFactorySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageFactorySettingsMutation, { data, loading, error }] = useUpdateImageFactorySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageFactorySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageFactorySettingsMutation, UpdateImageFactorySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImageFactorySettingsMutation, UpdateImageFactorySettingsMutationVariables>(UpdateImageFactorySettingsDocument, options);
      }
export type UpdateImageFactorySettingsMutationHookResult = ReturnType<typeof useUpdateImageFactorySettingsMutation>;
export type UpdateImageFactorySettingsMutationResult = Apollo.MutationResult<UpdateImageFactorySettingsMutation>;
export type UpdateImageFactorySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateImageFactorySettingsMutation, UpdateImageFactorySettingsMutationVariables>;
export const UpdateFleetControlSettingsDocument = gql`
    mutation UpdateFleetControlSettings($input: UpdateMSPAccount!) {
  updateMSPAccount(input: $input) {
    id
    products {
      fleetControl {
        ...FleetControlSettings
      }
    }
  }
}
    ${FleetControlSettingsFragmentDoc}`;
export type UpdateFleetControlSettingsMutationFn = Apollo.MutationFunction<UpdateFleetControlSettingsMutation, UpdateFleetControlSettingsMutationVariables>;

/**
 * __useUpdateFleetControlSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFleetControlSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFleetControlSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFleetControlSettingsMutation, { data, loading, error }] = useUpdateFleetControlSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFleetControlSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFleetControlSettingsMutation, UpdateFleetControlSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFleetControlSettingsMutation, UpdateFleetControlSettingsMutationVariables>(UpdateFleetControlSettingsDocument, options);
      }
export type UpdateFleetControlSettingsMutationHookResult = ReturnType<typeof useUpdateFleetControlSettingsMutation>;
export type UpdateFleetControlSettingsMutationResult = Apollo.MutationResult<UpdateFleetControlSettingsMutation>;
export type UpdateFleetControlSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFleetControlSettingsMutation, UpdateFleetControlSettingsMutationVariables>;
export const AddApiKeyDocument = gql`
    mutation AddApiKey($input: AddApiKey!, $accountId: ID!) {
  addApiKey(input: $input, accountId: $accountId) {
    ...ApiKeyRow
    key
  }
}
    ${ApiKeyRowFragmentDoc}`;
export type AddApiKeyMutationFn = Apollo.MutationFunction<AddApiKeyMutation, AddApiKeyMutationVariables>;

/**
 * __useAddApiKeyMutation__
 *
 * To run a mutation, you first call `useAddApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApiKeyMutation, { data, loading, error }] = useAddApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAddApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddApiKeyMutation, AddApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddApiKeyMutation, AddApiKeyMutationVariables>(AddApiKeyDocument, options);
      }
export type AddApiKeyMutationHookResult = ReturnType<typeof useAddApiKeyMutation>;
export type AddApiKeyMutationResult = Apollo.MutationResult<AddApiKeyMutation>;
export type AddApiKeyMutationOptions = Apollo.BaseMutationOptions<AddApiKeyMutation, AddApiKeyMutationVariables>;
export const RemoveApiKeyDocument = gql`
    mutation RemoveApiKey($prefix: ID!) {
  removeApiKey(prefix: $prefix) {
    prefix
  }
}
    `;
export type RemoveApiKeyMutationFn = Apollo.MutationFunction<RemoveApiKeyMutation, RemoveApiKeyMutationVariables>;

/**
 * __useRemoveApiKeyMutation__
 *
 * To run a mutation, you first call `useRemoveApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApiKeyMutation, { data, loading, error }] = useRemoveApiKeyMutation({
 *   variables: {
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useRemoveApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveApiKeyMutation, RemoveApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveApiKeyMutation, RemoveApiKeyMutationVariables>(RemoveApiKeyDocument, options);
      }
export type RemoveApiKeyMutationHookResult = ReturnType<typeof useRemoveApiKeyMutation>;
export type RemoveApiKeyMutationResult = Apollo.MutationResult<RemoveApiKeyMutation>;
export type RemoveApiKeyMutationOptions = Apollo.BaseMutationOptions<RemoveApiKeyMutation, RemoveApiKeyMutationVariables>;
export const ChangeAccountStatusDocument = gql`
    mutation ChangeAccountStatus($id: String!, $status: MSPAccountStatus!) {
  updateMSPAccount(input: {id: $id, status: $status}) {
    id
    status
    deletionRequest {
      requestingUserIdentity
      requestDeletionDate
    }
  }
}
    `;
export type ChangeAccountStatusMutationFn = Apollo.MutationFunction<ChangeAccountStatusMutation, ChangeAccountStatusMutationVariables>;

/**
 * __useChangeAccountStatusMutation__
 *
 * To run a mutation, you first call `useChangeAccountStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAccountStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAccountStatusMutation, { data, loading, error }] = useChangeAccountStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeAccountStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAccountStatusMutation, ChangeAccountStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAccountStatusMutation, ChangeAccountStatusMutationVariables>(ChangeAccountStatusDocument, options);
      }
export type ChangeAccountStatusMutationHookResult = ReturnType<typeof useChangeAccountStatusMutation>;
export type ChangeAccountStatusMutationResult = Apollo.MutationResult<ChangeAccountStatusMutation>;
export type ChangeAccountStatusMutationOptions = Apollo.BaseMutationOptions<ChangeAccountStatusMutation, ChangeAccountStatusMutationVariables>;
export const MspAccountsListDocument = gql`
    query MspAccountsList($query: String) {
  mspAccountsSearch(query: $query) {
    id
    ...AccountListRow
  }
}
    ${AccountListRowFragmentDoc}`;

/**
 * __useMspAccountsListQuery__
 *
 * To run a query within a React component, call `useMspAccountsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMspAccountsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMspAccountsListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMspAccountsListQuery(baseOptions?: Apollo.QueryHookOptions<MspAccountsListQuery, MspAccountsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MspAccountsListQuery, MspAccountsListQueryVariables>(MspAccountsListDocument, options);
      }
export function useMspAccountsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MspAccountsListQuery, MspAccountsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MspAccountsListQuery, MspAccountsListQueryVariables>(MspAccountsListDocument, options);
        }
export function useMspAccountsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MspAccountsListQuery, MspAccountsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MspAccountsListQuery, MspAccountsListQueryVariables>(MspAccountsListDocument, options);
        }
export type MspAccountsListQueryHookResult = ReturnType<typeof useMspAccountsListQuery>;
export type MspAccountsListLazyQueryHookResult = ReturnType<typeof useMspAccountsListLazyQuery>;
export type MspAccountsListSuspenseQueryHookResult = ReturnType<typeof useMspAccountsListSuspenseQuery>;
export type MspAccountsListQueryResult = Apollo.QueryResult<MspAccountsListQuery, MspAccountsListQueryVariables>;
export const AddMspAccountDocument = gql`
    mutation AddMSPAccount($input: AddMSPAccount!) {
  addMSPAccount(input: $input) {
    id
    ...AccountListRow
  }
}
    ${AccountListRowFragmentDoc}`;
export type AddMspAccountMutationFn = Apollo.MutationFunction<AddMspAccountMutation, AddMspAccountMutationVariables>;

/**
 * __useAddMspAccountMutation__
 *
 * To run a mutation, you first call `useAddMspAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMspAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMspAccountMutation, { data, loading, error }] = useAddMspAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMspAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddMspAccountMutation, AddMspAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMspAccountMutation, AddMspAccountMutationVariables>(AddMspAccountDocument, options);
      }
export type AddMspAccountMutationHookResult = ReturnType<typeof useAddMspAccountMutation>;
export type AddMspAccountMutationResult = Apollo.MutationResult<AddMspAccountMutation>;
export type AddMspAccountMutationOptions = Apollo.BaseMutationOptions<AddMspAccountMutation, AddMspAccountMutationVariables>;
export const MspAccountSelectItemDocument = gql`
    query MspAccountSelectItem {
  mspAccountsSearch {
    ...MspAccountSelectItem
  }
}
    ${MspAccountSelectItemFragmentDoc}`;

/**
 * __useMspAccountSelectItemQuery__
 *
 * To run a query within a React component, call `useMspAccountSelectItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMspAccountSelectItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMspAccountSelectItemQuery({
 *   variables: {
 *   },
 * });
 */
export function useMspAccountSelectItemQuery(baseOptions?: Apollo.QueryHookOptions<MspAccountSelectItemQuery, MspAccountSelectItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MspAccountSelectItemQuery, MspAccountSelectItemQueryVariables>(MspAccountSelectItemDocument, options);
      }
export function useMspAccountSelectItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MspAccountSelectItemQuery, MspAccountSelectItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MspAccountSelectItemQuery, MspAccountSelectItemQueryVariables>(MspAccountSelectItemDocument, options);
        }
export function useMspAccountSelectItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MspAccountSelectItemQuery, MspAccountSelectItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MspAccountSelectItemQuery, MspAccountSelectItemQueryVariables>(MspAccountSelectItemDocument, options);
        }
export type MspAccountSelectItemQueryHookResult = ReturnType<typeof useMspAccountSelectItemQuery>;
export type MspAccountSelectItemLazyQueryHookResult = ReturnType<typeof useMspAccountSelectItemLazyQuery>;
export type MspAccountSelectItemSuspenseQueryHookResult = ReturnType<typeof useMspAccountSelectItemSuspenseQuery>;
export type MspAccountSelectItemQueryResult = Apollo.QueryResult<MspAccountSelectItemQuery, MspAccountSelectItemQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: AddOrganization!) {
  addOrganization(input: $input) {
    ...OrganizationRow
  }
}
    ${OrganizationRowFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const OrganizationDocument = gql`
    query Organization($id: ID!) {
  organization(id: $id) {
    id
    ...Summary
    admins {
      ...Admin
    }
  }
}
    ${SummaryFragmentDoc}
${AdminFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export function useOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationSuspenseQueryHookResult = ReturnType<typeof useOrganizationSuspenseQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const OrganizationTenantsDocument = gql`
    query OrganizationTenants($id: ID!, $isAdmin: Boolean!) {
  organization(id: $id) {
    id
    status
    mspAccount {
      id
      products {
        klarity {
          enabled
          instanceLocations
          modes
        }
        imageFactory {
          enabled
          operatingSystems
          providers
        }
        fleetControl {
          enabled
          instanceLocations
          regions
        }
      }
    }
    klarityCoreTenants {
      ...KlarityCoreTenant
      apiKeys {
        ...ApiKeys
      }
      dashboard {
        ...KlarityDashboard
      }
      dashboardV2 @skip(if: $isAdmin) {
        ...KlarityDashboard
      }
    }
    imageFactoryTenants {
      ...ImageFactoryTenant
      dashboard {
        ...ImageFactoryDashboard
      }
    }
    fleetControlTenants {
      ...FleetControlTenant
    }
  }
}
    ${KlarityCoreTenantFragmentDoc}
${ApiKeysFragmentDoc}
${KlarityDashboardFragmentDoc}
${ImageFactoryTenantFragmentDoc}
${ImageFactoryDashboardFragmentDoc}
${FleetControlTenantFragmentDoc}`;

/**
 * __useOrganizationTenantsQuery__
 *
 * To run a query within a React component, call `useOrganizationTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTenantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useOrganizationTenantsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationTenantsQuery, OrganizationTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationTenantsQuery, OrganizationTenantsQueryVariables>(OrganizationTenantsDocument, options);
      }
export function useOrganizationTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationTenantsQuery, OrganizationTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationTenantsQuery, OrganizationTenantsQueryVariables>(OrganizationTenantsDocument, options);
        }
export function useOrganizationTenantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationTenantsQuery, OrganizationTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationTenantsQuery, OrganizationTenantsQueryVariables>(OrganizationTenantsDocument, options);
        }
export type OrganizationTenantsQueryHookResult = ReturnType<typeof useOrganizationTenantsQuery>;
export type OrganizationTenantsLazyQueryHookResult = ReturnType<typeof useOrganizationTenantsLazyQuery>;
export type OrganizationTenantsSuspenseQueryHookResult = ReturnType<typeof useOrganizationTenantsSuspenseQuery>;
export type OrganizationTenantsQueryResult = Apollo.QueryResult<OrganizationTenantsQuery, OrganizationTenantsQueryVariables>;
export const OrganizationAccountsDocument = gql`
    query OrganizationAccounts($filter: MSPAccountFilter) {
  mspAccountsSearch(filter: $filter) {
    products {
      fleetControl {
        regions
      }
    }
  }
}
    `;

/**
 * __useOrganizationAccountsQuery__
 *
 * To run a query within a React component, call `useOrganizationAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAccountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationAccountsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationAccountsQuery, OrganizationAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationAccountsQuery, OrganizationAccountsQueryVariables>(OrganizationAccountsDocument, options);
      }
export function useOrganizationAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationAccountsQuery, OrganizationAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationAccountsQuery, OrganizationAccountsQueryVariables>(OrganizationAccountsDocument, options);
        }
export function useOrganizationAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationAccountsQuery, OrganizationAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationAccountsQuery, OrganizationAccountsQueryVariables>(OrganizationAccountsDocument, options);
        }
export type OrganizationAccountsQueryHookResult = ReturnType<typeof useOrganizationAccountsQuery>;
export type OrganizationAccountsLazyQueryHookResult = ReturnType<typeof useOrganizationAccountsLazyQuery>;
export type OrganizationAccountsSuspenseQueryHookResult = ReturnType<typeof useOrganizationAccountsSuspenseQuery>;
export type OrganizationAccountsQueryResult = Apollo.QueryResult<OrganizationAccountsQuery, OrganizationAccountsQueryVariables>;
export const AddOrganizationAdminDocument = gql`
    mutation AddOrganizationAdmin($organizationId: String!, $input: AddAdmin!) {
  addOrganizationAdmin(organizationId: $organizationId, input: $input) {
    id
    admins {
      ...Admin
    }
  }
}
    ${AdminFragmentDoc}`;
export type AddOrganizationAdminMutationFn = Apollo.MutationFunction<AddOrganizationAdminMutation, AddOrganizationAdminMutationVariables>;

/**
 * __useAddOrganizationAdminMutation__
 *
 * To run a mutation, you first call `useAddOrganizationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationAdminMutation, { data, loading, error }] = useAddOrganizationAdminMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationAdminMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationAdminMutation, AddOrganizationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationAdminMutation, AddOrganizationAdminMutationVariables>(AddOrganizationAdminDocument, options);
      }
export type AddOrganizationAdminMutationHookResult = ReturnType<typeof useAddOrganizationAdminMutation>;
export type AddOrganizationAdminMutationResult = Apollo.MutationResult<AddOrganizationAdminMutation>;
export type AddOrganizationAdminMutationOptions = Apollo.BaseMutationOptions<AddOrganizationAdminMutation, AddOrganizationAdminMutationVariables>;
export const RemoveOrganizationAdminDocument = gql`
    mutation RemoveOrganizationAdmin($organizationId: String!, $adminId: String!) {
  removeOrganizationAdmin(organizationId: $organizationId, adminId: $adminId) {
    id
    admins {
      ...Admin
    }
  }
}
    ${AdminFragmentDoc}`;
export type RemoveOrganizationAdminMutationFn = Apollo.MutationFunction<RemoveOrganizationAdminMutation, RemoveOrganizationAdminMutationVariables>;

/**
 * __useRemoveOrganizationAdminMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationAdminMutation, { data, loading, error }] = useRemoveOrganizationAdminMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useRemoveOrganizationAdminMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganizationAdminMutation, RemoveOrganizationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganizationAdminMutation, RemoveOrganizationAdminMutationVariables>(RemoveOrganizationAdminDocument, options);
      }
export type RemoveOrganizationAdminMutationHookResult = ReturnType<typeof useRemoveOrganizationAdminMutation>;
export type RemoveOrganizationAdminMutationResult = Apollo.MutationResult<RemoveOrganizationAdminMutation>;
export type RemoveOrganizationAdminMutationOptions = Apollo.BaseMutationOptions<RemoveOrganizationAdminMutation, RemoveOrganizationAdminMutationVariables>;
export const UpdateOrganizationAdminDocument = gql`
    mutation UpdateOrganizationAdmin($organizationId: String!, $adminId: String!, $input: UpdateOrganizationAdmin!) {
  updateOrganizationAdmin(
    organizationId: $organizationId
    adminId: $adminId
    input: $input
  ) {
    id
    admins {
      ...Admin
    }
  }
}
    ${AdminFragmentDoc}`;
export type UpdateOrganizationAdminMutationFn = Apollo.MutationFunction<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>;

/**
 * __useUpdateOrganizationAdminMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAdminMutation, { data, loading, error }] = useUpdateOrganizationAdminMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      adminId: // value for 'adminId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>(UpdateOrganizationAdminDocument, options);
      }
export type UpdateOrganizationAdminMutationHookResult = ReturnType<typeof useUpdateOrganizationAdminMutation>;
export type UpdateOrganizationAdminMutationResult = Apollo.MutationResult<UpdateOrganizationAdminMutation>;
export type UpdateOrganizationAdminMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>;
export const RemoveKlarityCoreTenantDocument = gql`
    mutation RemoveKlarityCoreTenant($organizationId: String!, $klarityCoreTenantId: String!) {
  removeKlarityCoreTenant(
    organizationId: $organizationId
    klarityCoreTenantId: $klarityCoreTenantId
  ) {
    id
    klarityCoreTenants {
      ...KlarityCoreTenant
    }
  }
}
    ${KlarityCoreTenantFragmentDoc}`;
export type RemoveKlarityCoreTenantMutationFn = Apollo.MutationFunction<RemoveKlarityCoreTenantMutation, RemoveKlarityCoreTenantMutationVariables>;

/**
 * __useRemoveKlarityCoreTenantMutation__
 *
 * To run a mutation, you first call `useRemoveKlarityCoreTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKlarityCoreTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKlarityCoreTenantMutation, { data, loading, error }] = useRemoveKlarityCoreTenantMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      klarityCoreTenantId: // value for 'klarityCoreTenantId'
 *   },
 * });
 */
export function useRemoveKlarityCoreTenantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveKlarityCoreTenantMutation, RemoveKlarityCoreTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveKlarityCoreTenantMutation, RemoveKlarityCoreTenantMutationVariables>(RemoveKlarityCoreTenantDocument, options);
      }
export type RemoveKlarityCoreTenantMutationHookResult = ReturnType<typeof useRemoveKlarityCoreTenantMutation>;
export type RemoveKlarityCoreTenantMutationResult = Apollo.MutationResult<RemoveKlarityCoreTenantMutation>;
export type RemoveKlarityCoreTenantMutationOptions = Apollo.BaseMutationOptions<RemoveKlarityCoreTenantMutation, RemoveKlarityCoreTenantMutationVariables>;
export const AddKlarityCoreTenantDocument = gql`
    mutation AddKlarityCoreTenant($organizationId: String!, $input: AddOrganizationTenant!) {
  addKlarityCoreTenant(organizationId: $organizationId, input: $input) {
    id
    klarityCoreTenants {
      ...KlarityCoreTenant
    }
  }
}
    ${KlarityCoreTenantFragmentDoc}`;
export type AddKlarityCoreTenantMutationFn = Apollo.MutationFunction<AddKlarityCoreTenantMutation, AddKlarityCoreTenantMutationVariables>;

/**
 * __useAddKlarityCoreTenantMutation__
 *
 * To run a mutation, you first call `useAddKlarityCoreTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKlarityCoreTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKlarityCoreTenantMutation, { data, loading, error }] = useAddKlarityCoreTenantMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddKlarityCoreTenantMutation(baseOptions?: Apollo.MutationHookOptions<AddKlarityCoreTenantMutation, AddKlarityCoreTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddKlarityCoreTenantMutation, AddKlarityCoreTenantMutationVariables>(AddKlarityCoreTenantDocument, options);
      }
export type AddKlarityCoreTenantMutationHookResult = ReturnType<typeof useAddKlarityCoreTenantMutation>;
export type AddKlarityCoreTenantMutationResult = Apollo.MutationResult<AddKlarityCoreTenantMutation>;
export type AddKlarityCoreTenantMutationOptions = Apollo.BaseMutationOptions<AddKlarityCoreTenantMutation, AddKlarityCoreTenantMutationVariables>;
export const UpdateKlarityCoreTenantDocument = gql`
    mutation UpdateKlarityCoreTenant($input: UpdateOrganizationTenant!, $organizationId: String!) {
  updateKlarityCoreTenant(organizationId: $organizationId, input: $input) {
    id
  }
}
    `;
export type UpdateKlarityCoreTenantMutationFn = Apollo.MutationFunction<UpdateKlarityCoreTenantMutation, UpdateKlarityCoreTenantMutationVariables>;

/**
 * __useUpdateKlarityCoreTenantMutation__
 *
 * To run a mutation, you first call `useUpdateKlarityCoreTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKlarityCoreTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKlarityCoreTenantMutation, { data, loading, error }] = useUpdateKlarityCoreTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUpdateKlarityCoreTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKlarityCoreTenantMutation, UpdateKlarityCoreTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKlarityCoreTenantMutation, UpdateKlarityCoreTenantMutationVariables>(UpdateKlarityCoreTenantDocument, options);
      }
export type UpdateKlarityCoreTenantMutationHookResult = ReturnType<typeof useUpdateKlarityCoreTenantMutation>;
export type UpdateKlarityCoreTenantMutationResult = Apollo.MutationResult<UpdateKlarityCoreTenantMutation>;
export type UpdateKlarityCoreTenantMutationOptions = Apollo.BaseMutationOptions<UpdateKlarityCoreTenantMutation, UpdateKlarityCoreTenantMutationVariables>;
export const RemoveImageFactoryTenantDocument = gql`
    mutation RemoveImageFactoryTenant($organizationId: String!, $imageFactoryTenantId: String!) {
  removeImageFactoryTenant(
    organizationId: $organizationId
    imageFactoryTenantId: $imageFactoryTenantId
  ) {
    id
    imageFactoryTenants {
      ...ImageFactoryTenant
    }
  }
}
    ${ImageFactoryTenantFragmentDoc}`;
export type RemoveImageFactoryTenantMutationFn = Apollo.MutationFunction<RemoveImageFactoryTenantMutation, RemoveImageFactoryTenantMutationVariables>;

/**
 * __useRemoveImageFactoryTenantMutation__
 *
 * To run a mutation, you first call `useRemoveImageFactoryTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveImageFactoryTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeImageFactoryTenantMutation, { data, loading, error }] = useRemoveImageFactoryTenantMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      imageFactoryTenantId: // value for 'imageFactoryTenantId'
 *   },
 * });
 */
export function useRemoveImageFactoryTenantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveImageFactoryTenantMutation, RemoveImageFactoryTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveImageFactoryTenantMutation, RemoveImageFactoryTenantMutationVariables>(RemoveImageFactoryTenantDocument, options);
      }
export type RemoveImageFactoryTenantMutationHookResult = ReturnType<typeof useRemoveImageFactoryTenantMutation>;
export type RemoveImageFactoryTenantMutationResult = Apollo.MutationResult<RemoveImageFactoryTenantMutation>;
export type RemoveImageFactoryTenantMutationOptions = Apollo.BaseMutationOptions<RemoveImageFactoryTenantMutation, RemoveImageFactoryTenantMutationVariables>;
export const AddImageFactoryTenantDocument = gql`
    mutation AddImageFactoryTenant($organizationId: String!, $input: AddImageFactoryTenant!) {
  addImageFactoryTenant(organizationId: $organizationId, input: $input) {
    id
    imageFactoryTenants {
      ...ImageFactoryTenant
    }
  }
}
    ${ImageFactoryTenantFragmentDoc}`;
export type AddImageFactoryTenantMutationFn = Apollo.MutationFunction<AddImageFactoryTenantMutation, AddImageFactoryTenantMutationVariables>;

/**
 * __useAddImageFactoryTenantMutation__
 *
 * To run a mutation, you first call `useAddImageFactoryTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddImageFactoryTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addImageFactoryTenantMutation, { data, loading, error }] = useAddImageFactoryTenantMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddImageFactoryTenantMutation(baseOptions?: Apollo.MutationHookOptions<AddImageFactoryTenantMutation, AddImageFactoryTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddImageFactoryTenantMutation, AddImageFactoryTenantMutationVariables>(AddImageFactoryTenantDocument, options);
      }
export type AddImageFactoryTenantMutationHookResult = ReturnType<typeof useAddImageFactoryTenantMutation>;
export type AddImageFactoryTenantMutationResult = Apollo.MutationResult<AddImageFactoryTenantMutation>;
export type AddImageFactoryTenantMutationOptions = Apollo.BaseMutationOptions<AddImageFactoryTenantMutation, AddImageFactoryTenantMutationVariables>;
export const UpdateImageFactoryTenantDocument = gql`
    mutation UpdateImageFactoryTenant($input: UpdateOrganizationTenant!, $organizationId: String!) {
  updateImageFactoryTenant(organizationId: $organizationId, input: $input) {
    id
  }
}
    `;
export type UpdateImageFactoryTenantMutationFn = Apollo.MutationFunction<UpdateImageFactoryTenantMutation, UpdateImageFactoryTenantMutationVariables>;

/**
 * __useUpdateImageFactoryTenantMutation__
 *
 * To run a mutation, you first call `useUpdateImageFactoryTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageFactoryTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageFactoryTenantMutation, { data, loading, error }] = useUpdateImageFactoryTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUpdateImageFactoryTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageFactoryTenantMutation, UpdateImageFactoryTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImageFactoryTenantMutation, UpdateImageFactoryTenantMutationVariables>(UpdateImageFactoryTenantDocument, options);
      }
export type UpdateImageFactoryTenantMutationHookResult = ReturnType<typeof useUpdateImageFactoryTenantMutation>;
export type UpdateImageFactoryTenantMutationResult = Apollo.MutationResult<UpdateImageFactoryTenantMutation>;
export type UpdateImageFactoryTenantMutationOptions = Apollo.BaseMutationOptions<UpdateImageFactoryTenantMutation, UpdateImageFactoryTenantMutationVariables>;
export const RemoveFleetControlTenantDocument = gql`
    mutation RemoveFleetControlTenant($organizationId: String!, $fleetControlTenantId: String!) {
  removeFleetControlTenant(
    organizationId: $organizationId
    fleetControlTenantId: $fleetControlTenantId
  ) {
    id
    fleetControlTenants {
      ...FleetControlTenant
    }
  }
}
    ${FleetControlTenantFragmentDoc}`;
export type RemoveFleetControlTenantMutationFn = Apollo.MutationFunction<RemoveFleetControlTenantMutation, RemoveFleetControlTenantMutationVariables>;

/**
 * __useRemoveFleetControlTenantMutation__
 *
 * To run a mutation, you first call `useRemoveFleetControlTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFleetControlTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFleetControlTenantMutation, { data, loading, error }] = useRemoveFleetControlTenantMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fleetControlTenantId: // value for 'fleetControlTenantId'
 *   },
 * });
 */
export function useRemoveFleetControlTenantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFleetControlTenantMutation, RemoveFleetControlTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFleetControlTenantMutation, RemoveFleetControlTenantMutationVariables>(RemoveFleetControlTenantDocument, options);
      }
export type RemoveFleetControlTenantMutationHookResult = ReturnType<typeof useRemoveFleetControlTenantMutation>;
export type RemoveFleetControlTenantMutationResult = Apollo.MutationResult<RemoveFleetControlTenantMutation>;
export type RemoveFleetControlTenantMutationOptions = Apollo.BaseMutationOptions<RemoveFleetControlTenantMutation, RemoveFleetControlTenantMutationVariables>;
export const AddFleetControlTenantDocument = gql`
    mutation AddFleetControlTenant($organizationId: String!, $input: AddFleetControlTenant!) {
  addFleetControlTenant(organizationId: $organizationId, input: $input) {
    id
    fleetControlTenants {
      ...FleetControlTenant
    }
  }
}
    ${FleetControlTenantFragmentDoc}`;
export type AddFleetControlTenantMutationFn = Apollo.MutationFunction<AddFleetControlTenantMutation, AddFleetControlTenantMutationVariables>;

/**
 * __useAddFleetControlTenantMutation__
 *
 * To run a mutation, you first call `useAddFleetControlTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFleetControlTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFleetControlTenantMutation, { data, loading, error }] = useAddFleetControlTenantMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFleetControlTenantMutation(baseOptions?: Apollo.MutationHookOptions<AddFleetControlTenantMutation, AddFleetControlTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFleetControlTenantMutation, AddFleetControlTenantMutationVariables>(AddFleetControlTenantDocument, options);
      }
export type AddFleetControlTenantMutationHookResult = ReturnType<typeof useAddFleetControlTenantMutation>;
export type AddFleetControlTenantMutationResult = Apollo.MutationResult<AddFleetControlTenantMutation>;
export type AddFleetControlTenantMutationOptions = Apollo.BaseMutationOptions<AddFleetControlTenantMutation, AddFleetControlTenantMutationVariables>;
export const UpdateFleetControlTenantDocument = gql`
    mutation UpdateFleetControlTenant($input: UpdateFleetControlTenant!, $organizationId: String!) {
  updateFleetControlTenant(organizationId: $organizationId, input: $input) {
    id
  }
}
    `;
export type UpdateFleetControlTenantMutationFn = Apollo.MutationFunction<UpdateFleetControlTenantMutation, UpdateFleetControlTenantMutationVariables>;

/**
 * __useUpdateFleetControlTenantMutation__
 *
 * To run a mutation, you first call `useUpdateFleetControlTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFleetControlTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFleetControlTenantMutation, { data, loading, error }] = useUpdateFleetControlTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUpdateFleetControlTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFleetControlTenantMutation, UpdateFleetControlTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFleetControlTenantMutation, UpdateFleetControlTenantMutationVariables>(UpdateFleetControlTenantDocument, options);
      }
export type UpdateFleetControlTenantMutationHookResult = ReturnType<typeof useUpdateFleetControlTenantMutation>;
export type UpdateFleetControlTenantMutationResult = Apollo.MutationResult<UpdateFleetControlTenantMutation>;
export type UpdateFleetControlTenantMutationOptions = Apollo.BaseMutationOptions<UpdateFleetControlTenantMutation, UpdateFleetControlTenantMutationVariables>;
export const ChangeOrganizationNameDocument = gql`
    mutation ChangeOrganizationName($id: String!, $name: String!) {
  updateOrganization(input: {id: $id, name: $name}) {
    id
    name
  }
}
    `;
export type ChangeOrganizationNameMutationFn = Apollo.MutationFunction<ChangeOrganizationNameMutation, ChangeOrganizationNameMutationVariables>;

/**
 * __useChangeOrganizationNameMutation__
 *
 * To run a mutation, you first call `useChangeOrganizationNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrganizationNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrganizationNameMutation, { data, loading, error }] = useChangeOrganizationNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useChangeOrganizationNameMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOrganizationNameMutation, ChangeOrganizationNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOrganizationNameMutation, ChangeOrganizationNameMutationVariables>(ChangeOrganizationNameDocument, options);
      }
export type ChangeOrganizationNameMutationHookResult = ReturnType<typeof useChangeOrganizationNameMutation>;
export type ChangeOrganizationNameMutationResult = Apollo.MutationResult<ChangeOrganizationNameMutation>;
export type ChangeOrganizationNameMutationOptions = Apollo.BaseMutationOptions<ChangeOrganizationNameMutation, ChangeOrganizationNameMutationVariables>;
export const AddKlarityApiKeyDocument = gql`
    mutation AddKlarityApiKey($organizationId: ID!, $klarityTenantId: ID!, $input: AddKlarityApiKeyInput!) {
  addKlarityApiKey(
    organizationId: $organizationId
    klarityTenantId: $klarityTenantId
    input: $input
  ) {
    key
    ...ApiKeys
  }
}
    ${ApiKeysFragmentDoc}`;
export type AddKlarityApiKeyMutationFn = Apollo.MutationFunction<AddKlarityApiKeyMutation, AddKlarityApiKeyMutationVariables>;

/**
 * __useAddKlarityApiKeyMutation__
 *
 * To run a mutation, you first call `useAddKlarityApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKlarityApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKlarityApiKeyMutation, { data, loading, error }] = useAddKlarityApiKeyMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      klarityTenantId: // value for 'klarityTenantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddKlarityApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddKlarityApiKeyMutation, AddKlarityApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddKlarityApiKeyMutation, AddKlarityApiKeyMutationVariables>(AddKlarityApiKeyDocument, options);
      }
export type AddKlarityApiKeyMutationHookResult = ReturnType<typeof useAddKlarityApiKeyMutation>;
export type AddKlarityApiKeyMutationResult = Apollo.MutationResult<AddKlarityApiKeyMutation>;
export type AddKlarityApiKeyMutationOptions = Apollo.BaseMutationOptions<AddKlarityApiKeyMutation, AddKlarityApiKeyMutationVariables>;
export const RemoveKlarityApiKeyDocument = gql`
    mutation RemoveKlarityApiKey($klarityTenantId: ID!, $keyPrefix: ID!, $organizationId: ID!) {
  removeKlarityApiKey(
    klarityTenantId: $klarityTenantId
    keyPrefix: $keyPrefix
    organizationId: $organizationId
  ) {
    id
  }
}
    `;
export type RemoveKlarityApiKeyMutationFn = Apollo.MutationFunction<RemoveKlarityApiKeyMutation, RemoveKlarityApiKeyMutationVariables>;

/**
 * __useRemoveKlarityApiKeyMutation__
 *
 * To run a mutation, you first call `useRemoveKlarityApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKlarityApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKlarityApiKeyMutation, { data, loading, error }] = useRemoveKlarityApiKeyMutation({
 *   variables: {
 *      klarityTenantId: // value for 'klarityTenantId'
 *      keyPrefix: // value for 'keyPrefix'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRemoveKlarityApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveKlarityApiKeyMutation, RemoveKlarityApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveKlarityApiKeyMutation, RemoveKlarityApiKeyMutationVariables>(RemoveKlarityApiKeyDocument, options);
      }
export type RemoveKlarityApiKeyMutationHookResult = ReturnType<typeof useRemoveKlarityApiKeyMutation>;
export type RemoveKlarityApiKeyMutationResult = Apollo.MutationResult<RemoveKlarityApiKeyMutation>;
export type RemoveKlarityApiKeyMutationOptions = Apollo.BaseMutationOptions<RemoveKlarityApiKeyMutation, RemoveKlarityApiKeyMutationVariables>;
export const OrganizationsDocument = gql`
    query Organizations {
  organizations {
    ...OrganizationRow
  }
}
    ${OrganizationRowFragmentDoc}`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a React component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
      }
export function useOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
        }
export function useOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
        }
export type OrganizationsQueryHookResult = ReturnType<typeof useOrganizationsQuery>;
export type OrganizationsLazyQueryHookResult = ReturnType<typeof useOrganizationsLazyQuery>;
export type OrganizationsSuspenseQueryHookResult = ReturnType<typeof useOrganizationsSuspenseQuery>;
export type OrganizationsQueryResult = Apollo.QueryResult<OrganizationsQuery, OrganizationsQueryVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($id: String!) {
  removeOrganization(id: $id)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const ChangeOrganizationStatusDocument = gql`
    mutation ChangeOrganizationStatus($id: String!, $status: OrganizationStatus!) {
  updateOrganization(input: {id: $id, status: $status}) {
    id
    status
  }
}
    `;
export type ChangeOrganizationStatusMutationFn = Apollo.MutationFunction<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>;

/**
 * __useChangeOrganizationStatusMutation__
 *
 * To run a mutation, you first call `useChangeOrganizationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrganizationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrganizationStatusMutation, { data, loading, error }] = useChangeOrganizationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeOrganizationStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>(ChangeOrganizationStatusDocument, options);
      }
export type ChangeOrganizationStatusMutationHookResult = ReturnType<typeof useChangeOrganizationStatusMutation>;
export type ChangeOrganizationStatusMutationResult = Apollo.MutationResult<ChangeOrganizationStatusMutation>;
export type ChangeOrganizationStatusMutationOptions = Apollo.BaseMutationOptions<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>;
export const namedOperations = {
  Query: {
    Access: 'Access',
    MSPAccount: 'MSPAccount',
    UpdateAccountAfterDeletion: 'UpdateAccountAfterDeletion',
    KlarityProductSettings: 'KlarityProductSettings',
    ImageFactoryProductSettings: 'ImageFactoryProductSettings',
    FleetControlProductSettings: 'FleetControlProductSettings',
    MspAccountsList: 'MspAccountsList',
    MspAccountSelectItem: 'MspAccountSelectItem',
    Organization: 'Organization',
    OrganizationTenants: 'OrganizationTenants',
    OrganizationAccounts: 'OrganizationAccounts',
    Organizations: 'Organizations'
  },
  Mutation: {
    AddMSPAdmin: 'AddMSPAdmin',
    RemoveMSPAdmin: 'RemoveMSPAdmin',
    UpdateMSPAdmin: 'UpdateMSPAdmin',
    UpdateMSPAccount: 'UpdateMSPAccount',
    RemoveMSPAccount: 'RemoveMSPAccount',
    UpdateKlaritySettings: 'UpdateKlaritySettings',
    UpdateImageFactorySettings: 'UpdateImageFactorySettings',
    UpdateFleetControlSettings: 'UpdateFleetControlSettings',
    AddApiKey: 'AddApiKey',
    RemoveApiKey: 'RemoveApiKey',
    ChangeAccountStatus: 'ChangeAccountStatus',
    AddMSPAccount: 'AddMSPAccount',
    CreateOrganization: 'CreateOrganization',
    AddOrganizationAdmin: 'AddOrganizationAdmin',
    RemoveOrganizationAdmin: 'RemoveOrganizationAdmin',
    UpdateOrganizationAdmin: 'UpdateOrganizationAdmin',
    RemoveKlarityCoreTenant: 'RemoveKlarityCoreTenant',
    AddKlarityCoreTenant: 'AddKlarityCoreTenant',
    UpdateKlarityCoreTenant: 'UpdateKlarityCoreTenant',
    RemoveImageFactoryTenant: 'RemoveImageFactoryTenant',
    AddImageFactoryTenant: 'AddImageFactoryTenant',
    UpdateImageFactoryTenant: 'UpdateImageFactoryTenant',
    RemoveFleetControlTenant: 'RemoveFleetControlTenant',
    AddFleetControlTenant: 'AddFleetControlTenant',
    UpdateFleetControlTenant: 'UpdateFleetControlTenant',
    ChangeOrganizationName: 'ChangeOrganizationName',
    AddKlarityApiKey: 'AddKlarityApiKey',
    RemoveKlarityApiKey: 'RemoveKlarityApiKey',
    DeleteOrganization: 'DeleteOrganization',
    ChangeOrganizationStatus: 'ChangeOrganizationStatus'
  },
  Fragment: {
    Admin: 'Admin',
    AccountStatus: 'AccountStatus',
    MspAdmin: 'MspAdmin',
    FleetControlSettings: 'FleetControlSettings',
    ImageFactorySettings: 'ImageFactorySettings',
    KlarityProductSettings: 'KlarityProductSettings',
    ApiKeyRow: 'ApiKeyRow',
    AccountListRow: 'AccountListRow',
    Organization: 'Organization',
    MspAccountSelectItem: 'MspAccountSelectItem',
    Summary: 'Summary',
    ImageFactoryDashboard: 'ImageFactoryDashboard',
    CostDetails: 'CostDetails',
    KpiDetails: 'KpiDetails',
    Kpi: 'Kpi',
    Metrics: 'Metrics',
    Providers: 'Providers',
    KlarityDashboard: 'KlarityDashboard',
    ApiKeys: 'ApiKeys',
    OrganizationRow: 'OrganizationRow',
    FleetControlTenant: 'FleetControlTenant',
    ImageFactoryTenant: 'ImageFactoryTenant',
    KlarityCoreTenant: 'KlarityCoreTenant'
  }
}